// Field Manager

ButtonFieldManager = function (_settings) {
  this.create(_settings || {});
};
ButtonFieldManager.prototype = {
  /*
  _settings:
  - formTag, is used as the location to append the save and cancel buttons
  - showDefaultButtons (default=true), decides whether to
  And find any additional ones that need listing
  */
  create: function (_settings) {
      this.settings = _settings;

      this.items = [];

      gNotifier.display(_T('persistor starting...'));
      log.debug('Init field manager');

      this.settings.saveURL = _settings.saveURL === undefined ? _settings.loadURL : _settings.saveURL;
      this.settings.disableUnsavedChangesWarning = _settings.disableUnsavedChangesWarning === undefined ? false : _settings.disableUnsavedChangesWarning;
      this.had_changes = false;
      this.saving = false;

      this.formTag = $('form#' + this.settings.id);
      this.formTag.submit(this.save.bind(this));

      this.showDefaultButtons = _settings.showDefaultButtons === undefined ? true : Boolean(_settings.showDefaultButtons);

      this.isDirty = false;
      this.afterSaveCallback = _settings.afterSaveCallback === undefined ? false : _settings.afterSaveCallback;

      // We should prevent the user from navigating away with unsaved changes
      var self = this;
      window.addEventListener("beforeunload", function (e) {
          if (self.isDirty && !self.settings.disableUnsavedChangesWarning) {
              // confirmationMessage is only for older browsers, modern browsers don't allow custom messages,
              // but a confirm dialog will still be triggered (except perhaps on some mobile browsers)
              // See "Notes" on: https://developer.mozilla.org/es/docs/Web/Events/beforeunload
              var confirmationMessage = "You currently have unsaved changes, are you sure that you want to navigate away form the page?";
              e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
              return confirmationMessage;              // Gecko, WebKit, Chrome <34
          }
      });
  },
  busy: function () {
      for (var j in this.items) {
          var i = this.items[j];
          i.busy();
      }
      gNotifier.display(_T('persistor processing...'));
      log.debug('field manager busy');
  },
  ready: function () {
      for (var j in this.items) {
          var i = this.items[j];
          i.ready();
      }
      gNotifier.display(_T('persistor ready'));
      log.debug('field manager ready');
  },
  addItem: function (_item) {
      _item.link(this, this.settings.debug);
      this.items[_item.id] = _item;
  },
  removeItem: function (_item) {
      _item.unlink();
      delete this.items[_item.id];
  },
  getItem: function (_id) {
      if (isset(this.items[_id]))
          return this.items[_id];
      return null;
  },
  loadFromData: function (_data) {
      this.cleanData = _data;

      log.debug('field manager loadFromData called');
      for (var j in this.items) {
          var i = this.items[j];
          if (i.loadFromData) {
              i.loadFromData(_data);
          } else {
              i.val(_data[i.field]);
          }
      }
  },
  save: function (e) {
      if (e) { // We won't have an event set when this is called directly
          e.preventDefault();
      }

      if (!this.isDirty) { // There's nothing to save if the form isn't dirty
          return false;
      }

      var posts = {};

      for (var element in this.items) {
          var el = this.items[element];
          if (element === 'startpoint') {
              el.changed = true;
              el.saving = true;
              el.value = el.saveValue;
          }
          var value = el.get();

          var valid = el.settings.validate ? el.settings.validate(value) : true;

          if (!valid) {
              return false;
          }

          if (value !== undefined && el.isSubmitable()) {
              if (value != null && typeof (value) === 'object' && !$.isArray(value)) {
                  posts[value.field] = value.value;
              } else {
                  if (el.mode === 'JSON') {
                      posts[el.field] = JSON.parse(value);
                  } else {
                      posts[el.field] = el.get();
                  }
              }
          }
          el.save();
      }

      if (_.size(posts) > 0) {
          this.saving = true;
          gNotifier.saving();

          var rawData = { data: JSON.stringify(posts) };

          var self = this;
          $.ajax({
              url: this.settings.saveURL,
              global: false,
              type: 'POST',
              data: rawData,
              dataType: 'html'
          })
              .done(self.onSaveDone.bind(self))
              .fail(self.onSaveFail.bind(self))
              .always(function (_data) {
                  if (self.settings.always) {
                      self.settings.always(_data);
                  }
              });
          log.debug('field manager saving.')
      } else {
          log.debug('field manager has nothing to save.');
      }

      return false; // Prevent default behaviour
  },
  onSaveDone: function (_data) {
      if (this.settings.error_holder) {
          this.showErrorHolder();

          for (var item in this.items) {
              this.items[item].saved();
          }
      } else if (_data !== undefined) {
          let parsedData = JSON.parse(_data);
          let errorsInfo = null;
          // 2021-10-27: some forms like album info return a 200 status and reach this point although they might contain
          // errors on delegate entities like artists inside the multiple property, so we check the errors again here
          if (parsedData.multiple) {
              errorsInfo = parsedData.multiple;
          }

          for (var item in this.items) {
              item = this.items[item];
              if (errorsInfo) {
                  item.showError(errorsInfo[item.field]);
              }
              item.saved();
          }
      }
      if (this.settings.afterSuccess) {
          this.settings.afterSuccess(_data);
      }
      gNotifier.saved();
      this.had_changes = true;
      this.saving = false;
      if (this.settings.afterSaving) {
          this.settings.afterSaving(_data);
      }

      if (typeof this.settings.loadURL === 'undefined') {
          // We still need to hide the buttons after a save, even if there is no loadURL
          this.isDirty = false;
          this.renderControls();
          return;
      }

      var self = this;
      $.get(this.settings.loadURL)
          .done(function (_data) {
              self.cleanData = _data;
              self.isDirty = false;

              for (var item in self.items) {
                  item = self.items[item];
                  item.afterSave();
              }

              self.renderControls();
          });
  },
  onSaveFail: function (_data) {
      var responseText = _data.responseText ? JSON.parse(_data.responseText) : _data.statusText;

      if (this.settings.error_holder) {
          this.showErrorHolder('<ul>' + (new ApiResponse(responseText, { element: 'li' })).getHumanMsgs() + '</ul>');
          for (var item in this.items) {
              this.items[item].rollback();
          }
      } else {
          for (var item in this.items) {
              item = this.items[item];
              var field = responseText[item.field];

              // Is there an error for this
              if (field === true || field === undefined) {
                  // No error, clear this fields error messages
                  item.showError();
                  item.saved();
              } else {
                  // We have an error, display it
                  item.showError('<ul>' + (new ApiResponse(field, { element: 'li' })).getHumanMsgs() + '</ul>');
                  item.rollback();
              }
          }
      }

      this.renderControls();
      gNotifier.display(_T("persistor ready"));

      this.saving = false;
      if (this.settings.afterError) {
          this.settings.afterError(_data);
      }
      if (this.settings.afterSaving) {
          this.settings.afterSaving(_data);
      }
  },
  showErrorHolder: function (_str) {
      this.initErrorHolder();
      if (_str) {
          this.error_holder.html(_str).fadeIn(200);
      } else {
          this.error_holder.hide();
      }
  },
  initErrorHolder: function () {
      if (!this.error_holder) {
          this.error_holder = $('<div></div>').addClass('error').hide();
          this.settings.error_holder.append(this.error_holder);
      }
  },
  onChange: function (_id) { // Called on complete changes and keyups
      this.markDirty();
  },
  load: function () {
      if (!this.settings.loadURL) {
          return;
      }
      gNotifier.display(_T('persistor loading...'));
      log.debug('field manager loading fields');
      var self = this;
      $.get(this.settings.loadURL)
          .done(function (_data) {
              self.cleanData = _data;

              if (self.settings.onLoad) {
                  self.settings.onLoad(_data);
              }
              gNotifier.display(_T('persistor loaded'));
          });
  },
  cleanForm: function (e) {
      // This function is called by the cancel button at the bottom of the form
      e.preventDefault();

      if (confirm(_T("Confirm form cancel"))) {
          this.isDirty = false;
          window.location.reload();
          return;

          /*
          In the future an implementation more like this would be preferred:
          this.loadFromData(this.cleanData);
          this.isDirty = false;
          this.renderControls();
          But for the moment this causes bugs. Consider implementing once button_saves branch is merged
          */
      }

      return false;
  },
  markDirty: function () {
      this.isDirty = true;
      this.renderControls();
  },
  renderControls: function () {
      // This function isn't responsible for deciding whether the form is dirty or not,
      // just whether the controls should be displayed or not, based on this.dirty
      var controls = this.formTag.find('div.form_controls');

      if (this.isDirty && this.showDefaultButtons && controls.length === 0) {
          this.formTag.append($('<div/>', { class: "form_controls", style: "text-align:right;" }).append([
              $('<button/>', { class: "ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" }).append($('<span/>', { class: "ui-button-text" }).append(_T('Save'))).click(this.save.bind(this)),
              $('<button/>', { class: "button__primary--ghost ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" }).append($('<span/>', { class: "ui-button-text" }).append(_T('Cancel'))).click(this.cleanForm.bind(this))
          ]));
      } else if (!this.isDirty) {
          controls.remove();
      }
  },
  skipErrorCode: function (enabledErrorCodes, errorCode) {
      return !enabledErrorCodes.includes(errorCode);
  },
  addItemError: function (errorsPlaceholder, errorInfo) {
      let errorMessage = _T(errorInfo.message, [...errorInfo.params]);
      if (errorsPlaceholder.childNodes.length === 0) {
          let newErrorsList = document.createElement("ul");
          newErrorsList.classList.add('validation');
          newErrorsList.appendChild(this.createNewValidationErrorItem(errorMessage));
          errorsPlaceholder.appendChild(newErrorsList);
      } else {
          let existingErrorsList = errorsPlaceholder.firstChild;
          existingErrorsList.appendChild(this.createNewValidationErrorItem(errorMessage));
      }
  },
  createNewValidationErrorItem(errorMessage) {
      let newErrorItem = document.createElement("li");
      newErrorItem.classList.add('validation');
      newErrorItem.appendChild(document.createTextNode(errorMessage));
      return newErrorItem;
  },
  displayErrorCodes: function (violationsList, enabledErrorCodes) {
      violationsList.forEach((errorInfo) => {

          if (this.skipErrorCode(enabledErrorCodes, errorInfo.code)) {
              return;
          }

          const errorSelector = '.' + errorInfo.code + ' div.error';
          const errorFormItem = document.querySelector(errorSelector);

          if (errorFormItem) {
              this.addItemError(errorFormItem, errorInfo);
          }
      });
  },
  cleanValidationErrorCodes: function (enabledErrorCodes) {
      enabledErrorCodes.forEach((errorCode) => {
          const cleanerSelector = '.' + errorCode + ' div.error .validation';
          this.formTag.find(cleanerSelector).remove();
      });
  },
  hideAllErrors: function () {
      this.formTag.find('.error').hide();
  },
  showAllErrors: function () {
      this.formTag.find('.error').each(function () {
          if ($(this).html().length > 0) {
              $(this).show();
          }
      });
  },
};

/* ButtonFieldManager Release*/
ButtonFieldReleaseManager = function (_settings) {
  this.create(_settings || {});
};
ButtonFieldReleaseManager.prototype = {
  /*
  _settings:
  - formTag, is used as the location to append the save and cancel buttons
  - showDefaultButtons (default=true), decides whether to
  And find any additional ones that need listing
  */
  create: function (_settings) {
      this.settings = _settings;

      this.items = [];

      gNotifier.display(_T('persistor starting...'));
      log.debug('Init field manager');

      this.settings.saveURL = _settings.saveURL === undefined ? _settings.loadURL : _settings.saveURL;
      this.settings.disableUnsavedChangesWarning = _settings.disableUnsavedChangesWarning === undefined ? false : _settings.disableUnsavedChangesWarning;
      this.had_changes = false;
      this.saving = false;

      this.formTag = $('form#' + this.settings.id);
      this.formTag.submit(this.save.bind(this));

      this.showDefaultButtons = _settings.showDefaultButtons === undefined ? true : Boolean(_settings.showDefaultButtons);

      this.isDirty = false;
      this.afterSaveCallback = _settings.afterSaveCallback === undefined ? false : _settings.afterSaveCallback;

      // We should prevent the user from navigating away with unsaved changes
      var self = this;
      window.addEventListener("beforeunload", function (e) {
          if (self.isDirty && !self.settings.disableUnsavedChangesWarning) {
              // confirmationMessage is only for older browsers, modern browsers don't allow custom messages,
              // but a confirm dialog will still be triggered (except perhaps on some mobile browsers)
              // See "Notes" on: https://developer.mozilla.org/es/docs/Web/Events/beforeunload
              var confirmationMessage = "You currently have unsaved changes, are you sure that you want to navigate away form the page?";
              e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
              return confirmationMessage;              // Gecko, WebKit, Chrome <34
          }
      });
  },
  busy: function () {
      for (var j in this.items) {
          var i = this.items[j];
          i.busy();
      }
      gNotifier.display(_T('persistor processing...'));
      log.debug('field manager busy');
  },
  ready: function () {
      for (var j in this.items) {
          var i = this.items[j];
          i.ready();
      }
      gNotifier.display(_T('persistor ready'));
      log.debug('field manager ready');
  },
  addItem: function (_item) {
      _item.link(this, this.settings.debug);
      this.items[_item.id] = _item;
  },
  removeItem: function (_item) {
      _item.unlink();
      delete this.items[_item.id];
  },
  getItem: function (_id) {
      if (isset(this.items[_id]))
          return this.items[_id];
      return null;
  },
  loadFromData: function (_data) {
      this.cleanData = _data;

      log.debug('field manager loadFromData called');
      for (var j in this.items) {
          var i = this.items[j];
          if (i.loadFromData) {
              i.loadFromData(_data);
          } else {
              i.val(_data[i.field]);
          }
      }
  },
  save: function (e) {

      if (window.clarity) {
          window.clarity("event", this.settings.id + "_save");
      }

      if (e) { // We won't have an event set when this is called directly
          e.preventDefault();
      }

      if (!this.isDirty) { // There's nothing to save if the form isn't dirty
          return false;
      }

      var posts = {};

      for (var element in this.items) {
          var el = this.items[element];
          if (element === 'startpoint') {
              el.changed = true;
              el.saving = true;
              el.value = el.saveValue;
          }
          var value = el.get();

          var valid = el.settings.validate ? el.settings.validate(value) : true;

          if (!valid) {
              return false;
          }

          if (value !== undefined && el.isSubmitable()) {
              if (value != null && typeof (value) === 'object' && !$.isArray(value)) {
                  posts[value.field] = value.value;
              } else {
                  if (el.mode === 'JSON') {
                      posts[el.field] = JSON.parse(value);
                  } else {
                      posts[el.field] = el.get();
                  }
              }
          }
          el.save();
      }

      if (_.size(posts) > 0) {
          this.saving = true;
          gNotifier.saving();

          var rawData = { data: JSON.stringify(posts) };

          var self = this;
          $.ajax({
              url: this.settings.saveURL,
              global: false,
              type: 'POST',
              data: rawData,
              dataType: 'html'
          })
              .done(self.onSaveDone.bind(self))
              .fail(self.onSaveFail.bind(self))
              .always(function (_data) {
                  if (self.settings.always) {
                      self.settings.always(_data);
                  }
              });
          log.debug('field manager saving.')
      } else {
          log.debug('field manager has nothing to save.');
      }

      return false; // Prevent default behaviour
  },
  onSaveDone: function (_data) {
      if (this.settings.error_holder) {
          this.showErrorHolder();

          for (var item in this.items) {
              this.items[item].saved();
          }
      } else if (_data !== undefined) {
          let parsedData = JSON.parse(_data);
          let errorsInfo = null;
          // 2021-10-27: some forms like album info return a 200 status and reach this point although they might contain
          // errors on delegate entities like artists inside the multiple property, so we check the errors again here
          if (parsedData.multiple) {
              errorsInfo = parsedData.multiple;
          }

          for (var item in this.items) {
              item = this.items[item];
              if (errorsInfo) {
                  item.showError(errorsInfo[item.field]);
              }
              item.saved();
          }
      }
      if (this.settings.afterSuccess) {
          this.settings.afterSuccess(_data);
      }
      gNotifier.saved();
      this.had_changes = true;
      this.saving = false;
      if (this.settings.afterSaving) {
          this.settings.afterSaving(_data);
      }

      if (typeof this.settings.loadURL === 'undefined') {
          // We still need to hide the buttons after a save, even if there is no loadURL
          this.isDirty = false;
          this.renderControls();
          return;
      }

      var self = this;
      $.get(this.settings.loadURL)
          .done(function (_data) {
              self.cleanData = _data;
              self.isDirty = false;

              for (var item in self.items) {
                  item = self.items[item];
                  item.afterSave();
              }

              self.renderControls();
          });
  },
  onSaveFail: function (_data) {
      var responseText = _data.responseText ? JSON.parse(_data.responseText) : _data.statusText;

      if (this.settings.error_holder) {
          this.showErrorHolder('<ul>' + (new ApiResponse(responseText, { element: 'li' })).getHumanMsgs() + '</ul>');
          for (var item in this.items) {
              this.items[item].rollback();
          }
      } else {
          for (var item in this.items) {
              item = this.items[item];
              var field = responseText[item.field];

              // Is there an error for this
              if (field === true || field === undefined) {
                  // No error, clear this fields error messages
                  item.showError();
                  item.saved();
              } else {
                  // We have an error, display it
                  item.showError('<ul>' + (new ApiResponse(field, { element: 'li' })).getHumanMsgs() + '</ul>');
                  item.rollback();
              }
          }
      }

      this.renderControls();
      gNotifier.display(_T("persistor ready"));

      this.saving = false;
      if (this.settings.afterError) {
          this.settings.afterError(_data);
      }
      if (this.settings.afterSaving) {
          this.settings.afterSaving(_data);
      }
  },
  showErrorHolder: function (_str) {
      this.initErrorHolder();
      if (_str) {
          this.error_holder.html(_str).fadeIn(200);
      } else {
          this.error_holder.hide();
      }
  },
  initErrorHolder: function () {
      if (!this.error_holder) {
          this.error_holder = $('<div></div>').addClass('error').hide();
          this.settings.error_holder.append(this.error_holder);
      }
  },
  onChange: function (_id) { // Called on complete changes and keyups
      this.markDirty();
  },
  load: function () {
      if (!this.settings.loadURL) {
          return;
      }
      gNotifier.display(_T('persistor loading...'));
      log.debug('field manager loading fields');
      var self = this;
      $.get(this.settings.loadURL)
          .done(function (_data) {
              self.cleanData = _data;

              if (self.settings.onLoad) {
                  self.settings.onLoad(_data);
              }
              gNotifier.display(_T('persistor loaded'));
          });
  },
  cleanForm: function (e) {
      // This function is called by the cancel button at the bottom of the form
      e.preventDefault();

      if (confirm(_T("Confirm form cancel"))) {
          this.isDirty = false;
          window.location.reload();
          return;

          /*
          In the future an implementation more like this would be preferred:
          this.loadFromData(this.cleanData);
          this.isDirty = false;
          this.renderControls();
          But for the moment this causes bugs. Consider implementing once button_saves branch is merged
          */
      }

      return false;
  },
  markDirty: function () {
      this.isDirty = true;
      this.renderControls();
  },
  renderControls: function () {
      // This function isn't responsible for deciding whether the form is dirty or not,
      // just whether the controls should be displayed or not, based on this.dirty
      var controls = this.formTag.find('div.form_controls');

      if (this.isDirty && this.showDefaultButtons && controls.length === 0) {
          this.formTag.append($('<div/>', { class: "form_controls", style: "text-align:right; justify-content: flex-end; display: flex; gap: 24px;" }).append([
              $('<button/>', { class: "button__make-up button__primary--ghost ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" }).append($('<span/>', { class: "ui-button-text" }).append(_T('Cancel'))).click(this.cleanForm.bind(this)),
              $('<button/>', { class: "button__make-up ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" }).append($('<span/>', { class: "ui-button-text" }).append(_T('Save'))).click(this.save.bind(this))
          ]));
      } else if (!this.isDirty) {
          controls.remove();
      }
  },
  skipErrorCode: function (enabledErrorCodes, errorCode) {
      return !enabledErrorCodes.includes(errorCode);
  },
  addItemError: function (errorsPlaceholder, errorInfo) {
      let errorMessage = _T(errorInfo.message, [...errorInfo.params]);
      if (errorsPlaceholder.childNodes.length === 0) {
          let newErrorsList = document.createElement("ul");
          newErrorsList.classList.add('validation');
          newErrorsList.appendChild(this.createNewValidationErrorItem(errorMessage));
          errorsPlaceholder.appendChild(newErrorsList);
      } else {
          let existingErrorsList = errorsPlaceholder.firstChild;
          existingErrorsList.appendChild(this.createNewValidationErrorItem(errorMessage));
      }
  },
  createNewValidationErrorItem(errorMessage) {
      let newErrorItem = document.createElement("li");
      newErrorItem.classList.add('validation');
      newErrorItem.appendChild(document.createTextNode(errorMessage));
      return newErrorItem;
  },
  displayErrorCodes: function (violationsList, enabledErrorCodes) {
      violationsList.forEach((errorInfo) => {

          if (this.skipErrorCode(enabledErrorCodes, errorInfo.code)) {
              return;
          }

          const errorSelector = '.' + errorInfo.code + ' div.error';
          const errorFormItem = document.querySelector(errorSelector);

          if (errorFormItem) {
              this.addItemError(errorFormItem, errorInfo);
          }
      });
  },
  cleanValidationErrorCodes: function (enabledErrorCodes) {
      enabledErrorCodes.forEach((errorCode) => {
          const cleanerSelector = '.' + errorCode + ' div.error .validation';
          this.formTag.find(cleanerSelector).remove();
      });
  },
  hideAllErrors: function () {
      this.formTag.find('.error').hide();
  },
  showAllErrors: function () {
      this.formTag.find('.error').each(function () {
          if ($(this).html().length > 0) {
              $(this).show();
          }
      });
  },
};

// BtnFMControl
BtnFMControl = Class.extend({
  init: function (_settings) {
      this.id = _settings.id;
      this.settings = _settings;
      this.field = (_settings.field !== undefined) ? _settings.field : this.id;
      this.component = '';
      this.value = null;
      this.oldValue = null;
      this.submitable = (_settings.submitable !== undefined) ? _settings.submitable : true;
      this.changed = false;
      this.saving = false;
      this.mode = (_settings.mode !== undefined) ? _settings.mode : '';
  },
  check: function () {
      var check_result = this.hasItemChanged();
      this.changed = check_result.changed;
      this.debug('Check ' + JSON.stringify(check_result.new) + ' vs ' + JSON.stringify(this.oldValue) + ': ' + (this.changed ? 'changed' : 'not changed'));
      return this.changed;
  },
  hasItemChanged: function () {
      var v = this.get();
      return { old: this.oldValue, new: v, changed: v != this.oldValue };
  },
  save: function () {
      this.saveValue = this.get();
      this.startSaving();
  },
  startSaving: function () {
      this.debug('saving');
      this.saving = true;
  },
  saved: function () {
      if (this.saving) {
          this.oldValue = this.saveValue;
      }
      if (this.settings.onSaved) {
          this.settings.onSaved();
      }
      this.endSaving();
  },
  afterSave: function () {
      // Hook for usage by certain components
  },
  rollback: function () {
      if (this.saving) {
          this.set(this.oldValue);
      }
      this.endSaving();
  },
  endSaving: function () {
      this.debug('Saved.');
      this.saving = false;
  },
  set: function (_value) {
      this.value = _value;
      this.oldValue = _value;
      this.debug('v: ' + this.value + ' ov: ' + this.oldValue);
      return this;
  },
  get: function () {
      return this.value;
  },
  val: function (_var) {
      if (isset(_var)) {
          this.set(_var);
      } else {
          return this.get();
      }
  },
  onChange: function () {
      this.value = this.get();
      if (this.mgr) {
          this.mgr.onChange(this.id);
      }
  },
  link: function (_mgr, _debug) {
      this.mgr = _mgr;
      this.addError();
      if (_debug) this.addDebug();
  },
  unlink: function () {
      this.mgr = null;
      this.removeError();
      this.removeDebug();
  },
  addError: function () {
      this.error = $('<div/>').addClass('error').hide();
      $('#' + this.id).parent().append(this.error);
  },
  removeError: function () {
      $('#' + this.id + ' div.error').remove();
  },
  showError: function (_str) {
      if (_str) {
          this.error.html(_str).fadeIn(200);
      } else {
          this.error.empty();
      }
  },
  addDebug: function () {
      this.debug = $('<div></div>').addClass('debug');
      $('#' + this.id).parent().append(this.debug);
  },
  removeDebug: function () {
      $('#' + this.id + ' div.debug').remove();
  },
  debug: function (_str) {
      log.debug(this.field + ': ' + _str);
  },
  log: function (_str) {
      this.debug(_str);
  },
  ready: function () {
  },
  busy: function () {
  },
  isSubmitable: function () {
      return this.submitable;
  }
});


// BtnFMControl RELEASE
BtnFMReleaseControl = Class.extend({
  init: function (_settings) {
      this.id = _settings.id;
      this.settings = _settings;
      this.field = (_settings.field !== undefined) ? _settings.field : this.id;
      this.component = '';
      this.value = null;
      this.oldValue = null;
      this.submitable = (_settings.submitable !== undefined) ? _settings.submitable : true;
      this.changed = false;
      this.saving = false;
      this.mode = (_settings.mode !== undefined) ? _settings.mode : '';
  },
  check: function () {
      var check_result = this.hasItemChanged();
      this.changed = check_result.changed;
      this.debug('Check ' + JSON.stringify(check_result.new) + ' vs ' + JSON.stringify(this.oldValue) + ': ' + (this.changed ? 'changed' : 'not changed'));
      return this.changed;
  },
  hasItemChanged: function () {
      var v = this.get();
      return { old: this.oldValue, new: v, changed: v != this.oldValue };
  },
  save: function () {
      this.saveValue = this.get();
      this.startSaving();
  },
  startSaving: function () {
      this.debug('saving');
      this.saving = true;
  },
  saved: function () {
      if (this.saving) {
          this.oldValue = this.saveValue;
      }
      if (this.settings.onSaved) {
          this.settings.onSaved();
      }
      this.endSaving();
  },
  afterSave: function () {
      // Hook for usage by certain components
  },
  rollback: function () {
      if (this.saving) {
          this.set(this.oldValue);
      }
      this.endSaving();
  },
  endSaving: function () {
      this.debug('Saved.');
      this.saving = false;
  },
  set: function (_value) {
      this.value = _value;
      this.oldValue = _value;
      this.debug('v: ' + this.value + ' ov: ' + this.oldValue);
      return this;
  },
  get: function () {
      return this.value;
  },
  val: function (_var) {
      if (isset(_var)) {
          this.set(_var);
      } else {
          return this.get();
      }
  },
  onChange: function () {
      this.value = this.get();
      if (this.mgr) {
          this.mgr.onChange(this.id);
      }
  },
  link: function (_mgr, _debug) {
      this.mgr = _mgr;
      this.addError();
      if (_debug) this.addDebug();
  },
  unlink: function () {
      this.mgr = null;
      this.removeError();
      this.removeDebug();
  },
  addError: function () {
      this.error = $('<div/>').addClass('error input__error').hide();
      $('#' + this.id).parent().append(this.error);
  },
  removeError: function () {
      $('#' + this.id + ' div.error').remove();
  },
  showError: function (_str) {
      if (_str) {
          this.error.html(_str).fadeIn(200);
      } else {
          this.error.empty();
      }
  },
  addDebug: function () {
      this.debug = $('<div></div>').addClass('debug');
      $('#' + this.id).parent().append(this.debug);
  },
  removeDebug: function () {
      $('#' + this.id + ' div.debug').remove();
  },
  debug: function (_str) {
      log.debug(this.field + ': ' + _str);
  },
  log: function (_str) {
      this.debug(_str);
  },
  ready: function () {
  },
  busy: function () {
  },
  isSubmitable: function () {
      return this.submitable;
  }
});

BtnFMInput = BtnFMControl.extend({
  init: function (_settings) {
      var self = this;
      this._super(_settings);
      var debouncedOnChange = _.debounce(function () { self.mgr.markDirty(); }, 500);
      this.input = $('#' + this.id)
          .addClass('textbox')
          .bind('blur', function () { self.onChange(); })
          .bind('keyup', debouncedOnChange)
          .prop('disabled', true);

      if (_settings.busy) {
          this.busy();
      }

      if (_settings.keep) {
          this.set(this.input.val());
      } else {
          this.set('');
      }
  },
  onChange: function () {
      var v = this.get();
      if (this.settings.filter) {
          v = this.settings.filter(v);
      }

      var valid = this.settings.validate ? this.settings.validate(v) : true;

      if (valid) {
          this.input.val(v);
          this._super();
      } else {
          this.input.val(this.oldValue);
      }
  },
  set: function (_v) {
      if (this.settings.set_filter) {
          _v = this.settings.set_filter(_v);
      }
      this.input.val(_v);
      this._super(this.get());
  },
  ready: function () {
      if (this.settings.busy) {
          return;
      }
      this.input.prop('disabled', false).prop('readonly', false);
  },
  busy: function () {
      this.input.prop('disabled', true).prop('readonly', true);
  },
  get: function () {
      return this.input.val();
  }
});
// BtnFMInput RELEASE
BtnFMReleaseInput = BtnFMReleaseControl.extend({
  init: function (_settings) {
      var self = this;
      this._super(_settings);
      var debouncedOnChange = _.debounce(function () { self.mgr.markDirty(); }, 500);
      this.input = $('#' + this.id)
          .addClass('textbox')
          .bind('blur', function () { self.onChange(); })
          .bind('keyup', debouncedOnChange)
          .prop('disabled', true);

      if (_settings.busy) {
          this.busy();
      }

      if (_settings.keep) {
          this.set(this.input.val());
      } else {
          this.set('');
      }
  },
  onChange: function () {
      var v = this.get();
      if (this.settings.filter) {
          v = this.settings.filter(v);
      }

      var valid = this.settings.validate ? this.settings.validate(v) : true;

      if (valid) {
          this.input.val(v);
          this._super();
      } else {
          this.input.val(this.oldValue);
      }
  },
  set: function (_v) {
      if (this.settings.set_filter) {
          _v = this.settings.set_filter(_v);
      }
      this.input.val(_v);
      this._super(this.get());
  },
  ready: function () {
      if (this.settings.busy) {
          return;
      }
      this.input.prop('disabled', false).prop('readonly', false);
  },
  busy: function () {
      this.input.prop('disabled', true).prop('readonly', true);
  },
  get: function () {
      return this.input.val();
  }
});

BtnFMHidden = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      this.input = $('#' + this.id).prop('disabled', true);
  },
  set: function (_v) {
      this.input.val(_v);
      this._super(this.get());
  },
  ready: function () {
      this.input.prop('disabled', false).prop('readonly', false);
  },
  busy: function () {
      this.input.prop('disabled', true).prop('readonly', true);
  },
  get: function () {
      return this.input.val();
  }
});

BtnFMCKEditorInput = BtnFMControl.extend({
  init: function (_settings) {
      var self = this;

      if (!_settings.editor_settings) {
          _settings.editor_settings = {
              extraPlugins: 'youtube,vimeo',
              toolbar: [['Source',
                  'Format',
                  'Bold', 'Italic', '-',
                  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-',
                  'NumberedList', 'BulletedList', '-',
                  'Table', 'Image', '-',
                  'Link', 'Unlink', 'Anchor', '-',
                  'Youtube', 'Vimeo']]
          };
      }

      var o = CKEDITOR.instances[_settings.id];

      if (o) {
          o.destroy(true)
      }

      CKEDITOR.replace(_settings.id, _settings.editor_settings);

      var ed = CKEDITOR.instances[_settings.id];

      ed.on('blur', function () { self.onChange(); });
      var debouncedOnChange = _.debounce(function () { self.mgr.markDirty(); }, 500);
      ed.on('key', debouncedOnChange);

      this._super(_settings);
  },
  set: function (_v) {
      var o = CKEDITOR.instances[this.id];
      if (o) {
          o.setData(_v);
      } else {
          this._super(_v);
      }
  },
  get: function () {
      return CKEDITOR.instances[this.id].getData();
  }
});

////// BtnFMCheckBox RELEASE

BtnFMReleaseCheckBox = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      var self = this;
      this.checkbox = $('#' + this.id)
          .bind('click', function (_e) {
              if (self.settings.onClick) {
                  self.settings.onClick(_e);
              }
              self.onChange();
          });
      this.set(false);
  },
  set: function (_v) {
      var value = (_v * 1) ? true : false;
      this.checkbox.prop('checked', value);
      return this._super(value);
  },
  get: function () {
      return this.checkbox.first().get(0).checked;
  },
  ready: function () {
      this.checkbox.prop('disabled', false);
  },
  busy: function () {
      this.checkbox.prop('disabled', true);
  }
});

////// BtnFMCheckBox

BtnFMCheckBox = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      var self = this;
      this.checkbox = $('#' + this.id)
          .bind('click', function (_e) {
              if (self.settings.onClick) {
                  self.settings.onClick(_e);
              }
              self.onChange();
          });
      this.set(false);
  },
  set: function (_v) {
      var value = (_v * 1) ? true : false;
      this.checkbox.prop('checked', value);
      return this._super(value);
  },
  get: function () {
      return this.checkbox.first().get(0).checked;
  },
  ready: function () {
      this.checkbox.prop('disabled', false);
  },
  busy: function () {
      this.checkbox.prop('disabled', true);
  }
});

////// BtnFMSelect

BtnFMSelect = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      if (this.settings.isValid != null && this.settings.isValid != 'undefined') {
          this.isValid = this.settings.isValid
      }
      this.select = $('#' + this.id)
          .bind('change', { self: this }, function (_data) {
              if (_data.data.self.isValid != null && _data.data.self.isValid()) {
                  _data.data.self.onChange()
              } else if (_data.data.self.isValid == null) {
                  _data.data.self.onChange()
              } else {
                  $('#' + _data.data.self.id).val(_data.data.self.oldValue)
              }
          })
          .prop('disabled', true);
  },
  set: function (_v) {
      this.select.val(_v);
      this._super(_v);
  },
  get: function () {
      var value = $('option:selected', this.select).val();
      return (value == 0 || value == undefined) ? null : value;
  },
  ready: function () {
      this.select.prop('disabled', false);
  }
});

////// BtnFMDatePicker RELEASE
BtnFMDateReleasePicker = BtnFMReleaseControl.extend({
  init: function (_settings) {
      this._super(_settings);
      this.input = $('#' + this.id);

      var self = this;
      this.datepicker = this.input.datepicker({
          changeYear: true,
          changeMonth: true,
          dateFormat: $.datepicker.ISO_8601,
          altField: this.id,
          minDate: this.settings.minDate,
          maxDate: this.settings.maxDate,
          yearRange: this.settings.yearRange,
          showOn: "both",
          buttonText: '',
          buttonImage: _settings.image,
          buttonImageOnly: true,
          onSelect: function (dateText, inst) {
              if (this.value !== self.oldValue) {
                  self.set(this.value);
                  self.onChange();
              }
          },
          onClose: _settings.onClose
      });
  },
  check: function () {
      this.value = this.get();
      if (this.value == '' && this.oldValue == null) this.oldValue = '';
      return this._super();
  },
  set: function (_v) {

      this._super(_v);

      if (!_v || _v === '0000-00-00 00:00:00') {
          this.datepicker.datepicker('setDate', null);
          return false;
      }

      var reg = /^(19[0-9][0-9]|20[0-9][0-9])[- /.](0?[1-9]|1[012])[- /.](0?[1-9]|[1][0-9]|[2][0-9]|3[01]) (.*)$/;
      var m = _v.match(reg);

      if (m) {
          var d = new Date(m[1], m[2] - 1, m[3]);
          this.datepicker.datepicker('setDate', d);
      }
  },
  get: function () {
      return !this.input.val() ? null : this.input.val();
  }
});

////// BtnFMDatePicker

BtnFMDatePicker = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      this.input = $('#' + this.id);

      var self = this;
      this.datepicker = this.input.datepicker({
          changeYear: true,
          changeMonth: true,
          dateFormat: $.datepicker.ISO_8601,
          altField: this.id,
          minDate: this.settings.minDate,
          maxDate: this.settings.maxDate,
          yearRange: this.settings.yearRange,
          showOn: "both",
          buttonText: '',
          buttonImage: _settings.image,
          buttonImageOnly: true,
          onSelect: function (dateText, inst) {
              if (this.value !== self.oldValue) {
                  self.set(this.value);
                  self.onChange();
              }
          },
          onClose: _settings.onClose
      });

      var reset_btn = $('<a class="small button" href="#">x</a>').click(function () {
          const oldVal = self.oldValue;

          self.set(null);

          if (oldVal) {
              self.onChange();
          }

          return false;
      });

      this.input.after(reset_btn)
  },
  check: function () {
      this.value = this.get();
      if (this.value == '' && this.oldValue == null) this.oldValue = '';
      return this._super();
  },
  set: function (_v) {

      this._super(_v);

      if (!_v || _v === '0000-00-00 00:00:00') {
          this.datepicker.datepicker('setDate', null);
          return false;
      }

      var reg = /^(19[0-9][0-9]|20[0-9][0-9])[- /.](0?[1-9]|1[012])[- /.](0?[1-9]|[1][0-9]|[2][0-9]|3[01]) (.*)$/;
      var m = _v.match(reg);

      if (m) {
          var d = new Date(m[1], m[2] - 1, m[3]);
          this.datepicker.datepicker('setDate', d);
      }
  },
  get: function () {
      return !this.input.val() ? null : this.input.val();
  }
});

// From: https://github.com/KidSysco/jquery-ui-month-picker
BtnFMMonthPicker = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      this.input = $('#' + this.id);

      this.input.MonthPicker({
          ShowIcon: false
      });
  },
  check: function () {
      this.value = this.get();
      if (this.value == '' && this.oldValue == null) this.oldValue = '';
      return this._super();
  },
  set: function (_v) {
      this._super(_v);
      if (_v) {
          var reg = /^(19|20[0-9][0-9])[- /.](0?[1-9]|1[012])[- /.](0?[1-9]|[1][0-9]|[2][0-9]|3[01]) (.*)$/;
          var m = _v.match(reg);
          if (m) {
              var d = new Date(m[1], m[2] - 1, m[3]);
              this.datepicker.datepicker('setDate', d);
          }
      }
      this.input.val(_v);
  },
  get: function () {
      return this.input.val();
  }
});

// Artist Assigner RELEASE

BtnFMArtistAssignerReleaseControl = BtnFMReleaseControl.extend({

  init: function (_settings) {
      this._super(_settings);
      this.currentArtists = [];

      this.settings = _settings;
      this.container = $('#' + this.settings.id);

      this.user = this.settings.user;

      this.entityEndpoint = this.settings.entityEndpoint;

      this.displayArtistContainer = this.settings.displayArtistContainer;

      this.artistCache = this.settings.artistCache || [];
      this.artistAutocompleteCache = null;

      this.artistRoleId = null;

      this.modalId = this.settings.modalId;

      this.composeControl();
  },

  composeControl: function () {
      var that = this;

      this.artistAssignerRoleSelector = $('<input id="roleSelector" autocomplete="off" list="roles-option-list" type="text" class="input__box input--search"/>');
      this.rolesDataList = $('<datalist id="roles-option-list"></datalist> ');

      var roles = this.settings.roles;

      var translatedRoles = Object.fromEntries(
          Object.entries(roles).map(([key, value]) => {
              return [key, _T(value)];
          })
      );

      var reoderedRoles = this.reorderRoles(translatedRoles);

      _.each(reoderedRoles, function (_id) {
          that.rolesDataList.append($('<option data-id="' + _id + '"  value="' + translatedRoles[_id] + '" >' + translatedRoles[_id] + '</option>'));
      });

      this.artistAssignerRoleSelector.change(function () {

          var selectedOption = document.querySelector('#roles-option-list option[value="' + this.value + '"]');

          if (selectedOption) {
              that.artistRoleId = selectedOption.getAttribute('data-id');
          } else {
              that.artistAssignerRoleSelector.val("");
              that.artistRoleId = null;
          }
      });

      this.artistAssignerInput = $('<input size="45" type="text" class="input__box"/>').keyup(function () {
          that.artistAutocompleteCache = null;
      });

      this.artistAssignerInput.autocomplete(
          {
              source: function (_request, _callback) {
                  that.findGlobalArtistByName(_request.term, function (_items) {
                      _callback($.map(_items, function (_item) {
                          return {
                              value: _item.id,
                              label: _item.name
                          };
                      }));
                  });
              },
              select: function (_event, _ui) {
                  that.artistAssignerInput.val(_ui.item.label);
                  that.artistAutocompleteCache = _ui.item;
                  return false;
              }
          });

      this.artistAssignerButton = $('<button class="button__make-up" style="margin-bottom: 10px;"> <div style="display: flex;">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<g id="Icon / Add">\n' +
          '<path id="add_circle" d="M7.25 12H8.75V8.75H12V7.25H8.75V4H7.25V7.25H4V8.75H7.25V12ZM8.00575 16C6.9047 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0767 0.625 11.105C0.208333 10.1334 0 9.09519 0 7.99046C0 6.88571 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92332 1.04167 4.89496 0.625C5.86661 0.208333 6.90481 0 8.00954 0C9.11429 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92169 15.375 4.89008C15.7917 5.85849 16 6.89321 16 7.99425C16 9.09531 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0783 14.9583 11.1099 15.375C10.1415 15.7917 9.10679 16 8.00575 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" class="edit_text_color"/>\n' +
          '</g>\n' +
          '</svg>\n' +
          '</div>' + _T('add_artist') + '</button>').click(function () {
          that.addArtists();
          return false;
      });

      this.assignedArtists = $('<ul/>');

      var artistContentDiv = $('<div/>').append([
          this.artistAssignerRoleSelector,
          this.rolesDataList,
          this.artistAssignerInput,
          this.artistAssignerButton,
      ]);

      var artistsListDiv = $('<div/>').append(this.assignedArtists);

      this.container.append([
          artistContentDiv,
          artistsListDiv
      ]);

      this.assignedArtists.sortable({
          stop: function (_event, _ui) {
              that.reorderCurrentArtists(that.assignedArtists.sortable('toArray', { attribute: 'data-artist-id' }));
          }
      });
  },

  set: function (_artists) {
      this.currentArtists = _artists;
      this.reloadAssignedArtists();
  },

  get: function () {
      return this.currentArtists;
  },

  showError: function (errorsInfo) {
      if (!errorsInfo) {
          this.error.hide();
          return;
      }
      this.error
          .html('<ul>' + (new ApiResponse(errorsInfo, { element: 'li' })).getHumanMsgs() + '</ul>')
          .fadeIn(200);
  },


  afterSave: function () {
      this._super();
  },

  reloadAssignedArtists: function () {
      this.assignedArtists.html('');
      this.artistAssignerInput.val('');
      this.artistRoleId = null;
      this.artistAssignerRoleSelector.val("");
      var that = this;

      _.each(this.currentArtists, function (_currentArtist) {
          var artist_bar = $('<li></li>', {
              class: "item__list--artist",
          });
          artist_bar.attr("data-artist-id", _currentArtist.artist.id);
          var span = $('<div style="display: flex;"><img src="/images/make-up/icon/Move.svg" alt="move" width="16" height="16"></div>');
          var artistNameAndEditLink = $('<span style="display: flex; align-items: center; gap: 4px;"></span>');
          var artistName = $('<span></span>').text(_currentArtist.artist.name);
          var editLink = $('<span>', {
              text: ' | ' + _T('edit')
          });


          artistNameAndEditLink.append(artistName).append(editLink);

          var a = $('<a>', {
              href: "/artists/" + _currentArtist.artist.id,
              target: "_blank",
              class: "link",
              style: "margin-left: 5px; font-size: 14px; font-weight: 600;",
          }).append(artistNameAndEditLink);
          var span2 = $("<span style='display: flex;'></span>");
          a.text(_currentArtist.artist.name);
          a.append(editLink)
          span2.append(a);
          artist_bar.append(span, span2);

          _.each(_currentArtist.roles, function (_artist_role) {
              var role_bar = $('<span style="margin-left: 10px; display: flex; align-items: center;"><p class="text">' + _T(that.settings.roles[_artist_role]) + '</p></span>');

              var role_bar_delete = $('<button class="col-1 icon__container" style="margin-left: 5px;"> <div style="display: flex;"><img src="/images/make-up/icon/Remove.svg" alt="remove" width="16" height="16"></div></button>')
                  .bind('click', function () {
                      that.removeRoleFromCurrentArtist(_currentArtist.artist.id, _artist_role);
                      return false;
                  });

              role_bar.append(role_bar_delete);

              artist_bar.append(role_bar);
          });

          that.assignedArtists.append(artist_bar);
      });
  },

  findCurrentArtistById: function (_artist_id) {
      return _.find(this.currentArtists, function (currentArtist) {
          return currentArtist.artist.id == _artist_id;
      });
  },

  findCurrentArtistByName: function (_name) {
      return _.find(this.currentArtists, function (currentArtist) {
          return currentArtist.artist.name.toLowerCase() == _name.toLowerCase();
      });
  },

  findGlobalArtistByName: function (_name, callback) {
      callback = typeof callback === "undefined" ? false : callback;

      var url =
          '/api/1.0/artists/filter' +
          '/user/' + this.user.id +
          '/name/' + encodeURIComponent('%' + _name + '%') +
          '?pager[offset]=1&pager[limit]=100';

      $.get(url)
          .fail(function (_xhr) {
              if (callback) {
                  callback([]);
              }
          })
          .done(function (_data) {
              if (callback) {
                  callback(_data.items);
              }
          });
  },

  findGlobalArtistById: function (_artistId, callback) {
      var that = this;
      callback = typeof callback === "undefined" ? false : callback;
      var url = '/api/1.0/artists/' + _artistId;

      $.get(url)
          .fail()
          .done(function (_artist) {
              if (callback) {
                  callback(_artist);
              };
          });
  },

  checkDSPArtistId: function (_artistId, _role_id) {
      var that = this;
      const rolesToCheck = [1, 10];

      this.findGlobalArtistById(_artistId, function(_artist){
          if ( (!_artist.apple_id || !_artist.spotify_id) && rolesToCheck.includes(parseInt(_role_id)) )  {
              const modal = document.getElementById(that.modalId);
              const ctaButton = modal.querySelector('button');
              ctaButton.dataset.artistId = _artistId;
              modal.style.display = "grid";
          }
      })

  },

  reorderCurrentArtists: function (_artist_ids) {
      var that = this;
      var _currentArtists = [];

      _.each(_artist_ids, function (_artist_id) {
          _currentArtists.push(that.findCurrentArtistById(_artist_id));
      });

      this.currentArtists = _currentArtists;
      this.mgr.markDirty();
  },

  removeRoleFromCurrentArtist: function (_artist_id, _role_id) {
      var currentArtist = this.findCurrentArtistById(_artist_id);
      currentArtist.roles = _.without(currentArtist.roles, _role_id);

      if (currentArtist.roles.length === 0) {
          this.removeArtistFromCurrentArtist(_artist_id);
      }

      this.mgr.markDirty();
      this.reloadAssignedArtists();
  },

  removeArtistFromCurrentArtist: function (_artist_id) {
      this.currentArtists = _.without(
          _.map(this.currentArtists, function (currentArtist) {
              if (currentArtist.artist.id === _artist_id) {
                  return false;
              }
              return currentArtist;
          })
          , false);
  },

  addArtists: function () {
      var that = this;

      var name = this.artistAssignerInput.val();

      var separators = [' , ', ', ', ' and ', ' & ', ' - ', ' y ', ' \/ '];

      var names = name.split(new RegExp(separators.join('|'), 'g'));

      if (names.length > 1) {
          if (!confirm(_T('You have entered a character that indicates multiple artist names in one field. Add %s?', name))) {
              return false;
          }
      }

      this.mgr.markDirty();
      this.addArtist(name);
  },

  addArtist: function (name) {

      name = name.trim();

      if (!name || !this.artistRoleId) {
          return false;
      }

      var that = this;

      // If user has selected an artist via autocomplete we assign it directly
      if (this.artistAutocompleteCache) {
          if (currentArtist = this.findCurrentArtistById(this.artistAutocompleteCache.value)) {
              // Add role to current artist
              currentArtist.roles = _.union(currentArtist.roles, [this.artistRoleId]);
          }
          else {
              // Add new artist
              this.addCurrentArtist(this.artistAutocompleteCache.value, this.artistAutocompleteCache.label, this.artistRoleId);
          }

          this.mgr.markDirty();
          this.reloadAssignedArtists();

          return true;
      }

      // Add role to current artist if exists
      if (currentArtist = this.findCurrentArtistByName(name)) {
          currentArtist.roles = _.union(currentArtist.roles, [this.artistRoleId]);

          this.mgr.markDirty();
          this.reloadAssignedArtists();

          return true;
      }

      // Find global artist
      this.findGlobalArtistByName(name, function (_items) {
          // Add existing artist to current artists
          if (_items.length === 1 && _items[0].name === name) {
              that.addCurrentArtistAndRefresh(_items[0].id, _items[0].name, that.artistRoleId);
              return true;
          }

          // Create new artists
          $.post('/api/1.0/artists/', JSON.stringify({ name: name, created_by: that.user.id }))
              .done(function (_data) {
                  $.get(_data)
                      .done(function (_data) {
                          that.addCurrentArtistAndRefresh(parseInt(_data.id), _data.name, that.artistRoleId);
                      });
              });
      });
  },

  addCurrentArtist: function (_artist_id, _artist_name, _role_id) {

      this.checkDSPArtistId(_artist_id, _role_id);

      this.currentArtists.push(
          {
              artist:
              {
                  id: _artist_id,
                  name: _artist_name
              },
              roles: [_role_id]
          });
  },

  addCurrentArtistAndRefresh: function (_artist_id, _artist_name, _role_id) {
      this.addCurrentArtist(_artist_id, _artist_name, _role_id);

      this.mgr.markDirty();
      this.reloadAssignedArtists();
  },

  reorderRoles: function (roles) {

      const fixedRoles = ['1', '10', '7', '8', '5'];

      const keys = Object.keys(roles);
      const sortedFixedRoles = fixedRoles.filter(key => roles[key] !== undefined);
      const restRoles = keys.filter(key => !sortedFixedRoles.includes(key))
          .sort((a, b) => parseInt(roles[a].localeCompare(roles[b])));
      const reorderedRoles = [...sortedFixedRoles, ...restRoles];
      const reorderedObject = {};
      reorderedRoles.forEach(key => {
          reorderedObject[key] = roles[key];
      });

      return reorderedRoles;
  }

});


// Artist Assigner
BtnFMArtistAssignerControl = BtnFMControl.extend({

  init: function (_settings) {
      this._super(_settings);
      this.currentArtists = [];

      this.settings = _settings;
      this.container = $('#' + this.settings.id);

      this.user = this.settings.user;

      this.entityEndpoint = this.settings.entityEndpoint;

      this.displayArtistContainer = this.settings.displayArtistContainer;

      this.artistCache = this.settings.artistCache || [];
      this.artistAutocompleteCache = null;

      this.composeControl();
  },

  composeControl: function () {
      var that = this;

      this.artistAssignerRoleSelector = $('<select class="text" ></select>');

      _.each(this.settings.roles, function (_role, _id) {
          that.artistAssignerRoleSelector.append($('<option value="' + _id + '" >' + _T(_role) + '</option>'));
      });

      this.artistAssignerInput = $('<input size="45" type="text" />').keyup(function () {
          that.artistAutocompleteCache = null;
      });

      this.artistAssignerInput.autocomplete(
          {
              source: function (_request, _callback) {
                  that.findGlobalArtistByName(_request.term, function (_items) {
                      _callback($.map(_items, function (_item) {
                          return {
                              value: _item.id,
                              label: _item.name
                          };
                      }));
                  });
              },
              select: function (_event, _ui) {
                  that.artistAssignerInput.val(_ui.item.label);
                  that.artistAutocompleteCache = _ui.item;
                  return false;
              }
          });

      this.artistAssignerButton = $('<input type="button" value="' + _T('add_artist') + '" />').click(function () {
          that.addArtists();
          return false;
      });

      this.assignedArtists = $('<ul/>', {
          class: 'list'
      });

      this.container.append([
          this.artistAssignerRoleSelector,
          this.artistAssignerInput,
          this.artistAssignerButton,
          this.assignedArtists
      ]);

      this.assignedArtists.sortable({
          stop: function (_event, _ui) {
              that.reorderCurrentArtists(that.assignedArtists.sortable('toArray', { attribute: 'data-artist-id' }));
          }
      });
  },

  set: function (_artists) {
      this.currentArtists = _artists;
      this.reloadAssignedArtists();

      if (this.mgr) {
          this.displayArtistContainer.text(this.mgr.cleanData.display_artist);
      }
  },

  get: function () {
      return this.currentArtists;
  },

  showError: function (errorsInfo) {
      if (!errorsInfo) {
          this.error.hide();
          return;
      }
      this.error
          .html('<ul>' + (new ApiResponse(errorsInfo, { element: 'li' })).getHumanMsgs() + '</ul>')
          .fadeIn(200);
  },


  afterSave: function () {
      this._super();
      this.displayArtistContainer.text(this.mgr.cleanData.display_artist);
  },

  reloadAssignedArtists: function () {
      this.assignedArtists.html('');
      this.artistAssignerInput.val('');

      var that = this;

      _.each(this.currentArtists, function (_currentArtist) {
          var artist_bar = $('<li></li>', {
              class: "button"
          });
          artist_bar.attr("data-artist-id", _currentArtist.artist.id);
          var span = $('<div style="display: flex;"><img src="/images/make-up/icon/Move.svg" alt="move" width="16" height="16"></div>');
          var span2 = $("<span></span>");
          var a = $('<a>', {
              href: "/artists/" + _currentArtist.artist.id
          });

          a.text(_currentArtist.artist.name);

          span2.append(a);
          artist_bar.append(span, span2);

          _.each(_currentArtist.roles, function (_artist_role) {
              var role_bar = $('<span> ' + _T(that.settings.roles[_artist_role]) + '</span>');

              var role_bar_delete = $('<a class="button small" href="#">x</a>')
                  .bind('click', function () {
                      that.removeRoleFromCurrentArtist(_currentArtist.artist.id, _artist_role);
                      return false;
                  });

              role_bar.append(role_bar_delete);

              artist_bar.append(role_bar);
          });

          that.assignedArtists.append(artist_bar);
      });
  },

  findCurrentArtistById: function (_artist_id) {
      return _.find(this.currentArtists, function (currentArtist) {
          return currentArtist.artist.id == _artist_id;
      });
  },

  findCurrentArtistByName: function (_name) {
      return _.find(this.currentArtists, function (currentArtist) {
          return currentArtist.artist.name.toLowerCase() == _name.toLowerCase();
      });
  },

  findGlobalArtistByName: function (_name, callback) {
      callback = typeof callback === "undefined" ? false : callback;

      var url =
          '/api/1.0/artists/filter' +
          '/user/' + this.user.id +
          '/name/' + encodeURIComponent('%' + _name + '%') +
          '?pager[offset]=1&pager[limit]=100';

      $.get(url)
          .fail(function (_xhr) {
              if (callback) {
                  callback([]);
              }
          })
          .done(function (_data) {
              if (callback) {
                  callback(_data.items);
              }
          });
  },

  reorderCurrentArtists: function (_artist_ids) {
      var that = this;
      var _currentArtists = [];

      _.each(_artist_ids, function (_artist_id) {
          _currentArtists.push(that.findCurrentArtistById(_artist_id));
      });

      this.currentArtists = _currentArtists;
      this.mgr.markDirty();
  },

  removeRoleFromCurrentArtist: function (_artist_id, _role_id) {
      var currentArtist = this.findCurrentArtistById(_artist_id);
      currentArtist.roles = _.without(currentArtist.roles, _role_id);

      if (currentArtist.roles.length === 0) {
          this.removeArtistFromCurrentArtist(_artist_id);
      }

      this.mgr.markDirty();
      this.reloadAssignedArtists();
  },

  removeArtistFromCurrentArtist: function (_artist_id) {
      this.currentArtists = _.without(
          _.map(this.currentArtists, function (currentArtist) {
              if (currentArtist.artist.id === _artist_id) {
                  return false;
              }
              return currentArtist;
          })
          , false);
  },

  addArtists: function () {
      var that = this;

      var name = this.artistAssignerInput.val();

      var separators = [' , ', ', ', ' and ', ' & ', ' - ', ' y ', ' \/ '];

      var names = name.split(new RegExp(separators.join('|'), 'g'));

      if (names.length > 1) {
          if (!confirm(_T('You have entered a character that indicates multiple artist names in one field. Add %s?', name))) {
              return false;
          }
      }

      this.mgr.markDirty();
      this.addArtist(name);
  },

  addArtist: function (name) {
      name = name.trim();

      if (!name) {
          return false;
      }

      var that = this;

      // If user has selected an artist via autocomplete we assign it directly
      if (this.artistAutocompleteCache) {
          if (currentArtist = this.findCurrentArtistById(this.artistAutocompleteCache.value)) {
              // Add role to current artist
              currentArtist.roles = _.union(currentArtist.roles, [this.artistAssignerRoleSelector.val()]);
          }
          else {
              // Add new artist
              this.addCurrentArtist(this.artistAutocompleteCache.value, this.artistAutocompleteCache.label, this.artistAssignerRoleSelector.val());
          }

          this.mgr.markDirty();
          this.reloadAssignedArtists();

          return true;
      }

      // Add role to current artist if exists
      if (currentArtist = this.findCurrentArtistByName(name)) {
          currentArtist.roles = _.union(currentArtist.roles, [this.artistAssignerRoleSelector.val()]);

          this.mgr.markDirty();
          this.reloadAssignedArtists();

          return true;
      }

      // Find global artist
      this.findGlobalArtistByName(name, function (_items) {
          // Add existing artist to current artists
          if (_items.length === 1 && _items[0].name === name) {
              that.addCurrentArtistAndRefresh(_items[0].id, _items[0].name, that.artistAssignerRoleSelector.val());
              return true;
          }

          // Create new artists
          $.post('/api/1.0/artists/', JSON.stringify({ name: name, created_by: that.user.id }))
              .done(function (_data) {
                  $.get(_data)
                      .done(function (_data) {
                          that.addCurrentArtistAndRefresh(parseInt(_data.id), _data.name, that.artistAssignerRoleSelector.val());
                      });
              });
      });
  },

  addCurrentArtist: function (_artist_id, _artist_name, _role_id) {
      this.currentArtists.push(
          {
              artist:
              {
                  id: _artist_id,
                  name: _artist_name
              },
              roles: [_role_id]
          });
  },

  addCurrentArtistAndRefresh: function (_artist_id, _artist_name, _role_id) {
      this.addCurrentArtist(_artist_id, _artist_name, _role_id);

      this.mgr.markDirty();
      this.reloadAssignedArtists();
  }

});

/////////////////////////
// UniversalCodeControl
//
BtnFMUniversalCodeControl = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      this.changedCode = false;

      if (_settings.manager) {
          if (!this.settings.assigned && this.settings.assign_code && this.settings.state !== 'DRAFT') {
              $('#' + this.settings.code + '_container').hide();
              $('#' + this.settings.code + '_assigned_container').html(_T('code will be automatically assigned.'));
              $('#' + this.settings.code + '_assigned_container').show();
          } else if (this.settings.assigned || (this.settings.current !== "" && this.settings.state !== 'DRAFT')) {
              $('#' + this.settings.code + '_container').hide();
              $('#' + this.settings.code + '_assigned_container').html(_T('code %s has already been assigned.', this.settings.current));
              $('#' + this.settings.code + '_assigned_container').show();
          } else {
              var code = $('#' + this.settings.prefix + '_' + this.settings.code);
              this.code = code.get(0);
              var assign = $('#' + this.settings.prefix + '_' + this.settings.assign);
              this.assign = assign.get(0);

              this.settings.manager.addItem(this);

              code.bind('change', this.onChange.bind(this, true));
              assign.bind('change', this.onChange.bind(this, false));

              $('#' + this.settings.code + '_container').show();
              $('#' + this.settings.code + '_assigned_container').hide();
          }
      }
  },
  assignBusy: function () {
      $('#' + this.settings.prefix + '_' + this.settings.assign).prop('disabled', true).prop('readonly', true);
      $('#' + this.settings.prefix + '_' + this.settings.assign + '_label').removeAttr('for');
  },
  assignReady: function () {
      $('#' + this.settings.prefix + '_' + this.settings.assign).prop('disabled', false).prop('readonly', false);
      $('#' + this.settings.prefix + '_' + this.settings.assign + '_label').attr('for', this.settings.prefix + '_' + this.settings.assign);
  },
  reset: function (_settings) {
      if (this.mgr != undefined) {
          this.mgr.removeItem(this);
          this.mgr = null;

          $('#' + this.code.id).unbind('blur');
          $('#' + this.assign.id).unbind('blur');

          this.code = null;
          this.assign = null;
      }

      this.init(_settings);
  },
  onChange: function (_inCode) {
      // _inCode = (true = change came from text input, false = change came from checkbox)
      if (_inCode) {
          if ((filtered = this.filterValue(this.get().value)) != this.get().value) {
              $('#' + this.code.id).val(filtered);
              this.set(filtered);
          }

          // Set the checkbox to false
          $('#' + this.assign.id).prop('checked', false);
      }
      else {
          // Set the textbox to be empty
          $('#' + this.code.id).val('');
      }

      this.changedCode = _inCode;
      this._super();
  },
  filterValue: function (value) {
      if (this.settings.filterValue) {
          return this.settings.filterValue(value);
      }
      return value;
  },
  hasItemChanged: function () {
      var current = this.get();
      return {
          old: this.oldValue,
          new: current,
          changed: (this.oldValue != null) && ((current.field != this.oldValue.field) || (current.value != this.oldValue.value))
      };
  },
  loadFromData: function (_data) {
      if (_data[this.settings.assign] == 1) {
          this.set({ field: this.settings.assign, value: true });
          this.changedCode = false;
      } else {
          this.set({
              field: this.settings.code,
              value: _data[this.settings.code] != null ? _data[this.settings.code] : ''
          });
          this.changedCode = true;
      }
  },
  saved: function () {
      this._super();
      this.set(this.oldValue);
      this.ready();
  },
  rollback: function () {
      this._super();
      this.ready();
  },
  set: function (_value) {
      if (_value.field == this.settings.code) {
          this.code.value = (this.settings.onLoadProcess) ? this.settings.onLoadProcess(_value.value) : _value.value;
          this.assign.checked = false;
      } else if (_value.field == this.settings.assign) {
          this.code.value = '';
          this.assign.checked = _value.value;
      }
      this._super(_value);
  },
  get: function () {
      if (this.changedCode) {
          return { field: this.settings.code, value: this.code.value };
      } else {
          return { field: this.settings.assign, value: this.assign.checked };
      }
  },
  ready: function () {
      $('#' + this.code.id).prop('disabled', false);
      $('#' + this.code.id).prop('readonly', false);
      this.assignReady();
  },
  busy: function () {
      $('#' + this.code.id).prop('disabled', true);
      $('#' + this.code.id).prop('readonly', true);
      this.assignBusy();
  }
});
//
// End of UniversalCodeControl
/////////////////////////
// TagControl
//
BtnFMTagControl = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);

      this.source = [];

      this.container = $('#' + _settings.id);

      this.composeControl();

      this.onData(_settings.tags ? _settings.tags : []);

      this.render();
  },
  composeControl: function () {
      this.id_list = $('<input type="text" id="' + this.settings.id + '_input" size="' + this.settings.input_size + '"/>');
      var self = this;
      this.add = $('<input id="' + this.settings.id + '_add" data-add type="button" value="' + _T('add_tag') + '" />').click(function () {
          self.addTag(self.id_list.val());
          self.id_list.val('');
          return false;
      });

      this.source = _.map(self.settings.all, function (_value) {
          return _value[self.settings.property];
      });
      this.id_list.autocomplete({ source: self.source });

      this.id_list.keyup(function (_event) {
          if (_event.keyCode == 13) {
              self.addTag(self.id_list.val());
              self.id_list.val('');
          }
      });

      this.selected = $('<ul class="button_holder" id="' + this.settings.id + '_selected"></ul>');

      this.container
          .append(this.selected)
          .append($('<br style="clear:both" />'))
          .append(this.id_list)
          .append(this.add);
  },
  render: function () {
      this.selected.html('');
      var self = this;
      _.each(this.tags, function (_tag, _i) {
          var a = $('<a class="button small">x</a>');
          a.bind('click', function () {
              self.tags = _.filter(self.tags, function (_item) { return _item != _tag; });
              a.fadeOut(500, function () {
                  self.render();
                  self.onChange();
              });
              return false;
          });
          self.selected.append($('<li class="selected_tag">' + _tag + '</li>').append(a));
      });
  },
  addTag: function (_tag) {
      if (!_tag || _.include(this.tags, _tag)) {
          return;
      }
      this.tags.push(_tag);
      this.render();
      this.onChange();
  },
  hasItemChanged: function () {
      var current = this.get();
      var changed = false;
      if (current.length != this.oldValue.length) {
          changed = true;
      }
      for (var j in current) {
          if (current[j] != this.oldValue[j]) {
              changed = true;
              break;
          }
      }
      return { old: this.oldValue, new: current, changed: changed };
  },
  get: function () {
      return this.tags.slice(0);
  },
  set: function (_value) {
      _value.sort();
      this._super(_value);
      this.tags = _value.slice(0);
      this.render();
  },
  onData: function (_data) {
      var self = this;
      this.set(_.map(_data, function (_item) { return (typeof (_item) == 'object') ? _item[self.settings.property] : _item; }));
  },
  loadFromData: function (_data) {
      if (_data[this.field] === undefined) {
          return;
      }
      this.onData((_data[this.field].items !== undefined) ? _data[this.field].items : _data[this.field]);
  },
  ready: function () {
      this.id_list.prop('disabled', false).prop('readonly', false).autocomplete('enable');
      this.add.prop('disabled', false).prop('readonly', false);
  },
  busy: function () {
      this.id_list.prop('disabled', true).prop('readonly', true).autocomplete('disable');
      this.add.prop('disabled', true).prop('readonly', true);
  }
});
//
// End of TagControl
/////////////////////////
// BtnFMLabelAssigner
//

BtnFMLabelAssigner = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);

      this.settings = _settings;

      this.value = null;

      this.composeControl();
      this.load();
  },
  save: function () {
      this._super();
  },
  composeControl: function () {
      var editDialog = $('<div/>').attr('id', 'label_dialog');
      this.options = $('<span/>');
      var editAction = $('<button id="' + this.settings.id + '_edit" style="float:left">' + _T('Edit label') + '</button>');
      this.input = $('<input type="text" id="' + this.settings.id + '_input" />');

      $('#' + this.settings.id).append([
          this.options,
          editAction,
          $('<span/>').append([
              this.input,
              $('<input id="' + this.settings.id + '_add" type="button" value="' + _T('Add new label') + '" />')
                  .click(this.postAddData.bind(this)),
              editDialog
          ])
      ]);

      var self = this;
      editAction.click(function () {
          self.loadLabel($('select[id=' + self.settings.id + '_selector]').val());
          return false;
      });
  },
  load: function () {
      var self = this;
      var verify_selected = function (_data) {
          if (_.isEmpty(_.find(_data.items, function (_l) { return _l.id == self.value; }))) {
              $.get(self.settings.getLabelUrl + self.value)
                  .done(function (_label) {
                      _data.items.unshift(_label);
                      self.onData(_data);
                  })
          } else {
              self.onData(_data);
          }
      };

      if (this.settings.initial) {
          verify_selected(this.settings.initial);
          delete (this.settings.initial);
      } else {
          $.get(this.settings.values).done(function (_data) { verify_selected(_data); });
      }
  },
  set: function (_label) {
      this.value = parseInt(_label);
  },
  get: function () {
      return this.value;
  },
  loadFromData: function (_label) {
      this.value = parseInt(_label.label_id);
  },
  onData: function (_data) {
      this.options.html('');
      var selector = $('<select id="' + this.settings.id + '_selector' + '"></select>');
      this.options.append(selector);
      for (var j in _data.items) {
          var i = _data.items[j];
          var id = this.settings.id + '_option';
          var r_input = $('<option id="' + id + '_' + i.id + '" name="' + id + '" value="' + i.id + '" >' + i.name + '</option>');
          if (i.id == this.value) {
              r_input.prop('selected', true);
          }
          selector.append(r_input);
      }

      selector.change(this.postSelectData.bind(this));

      postRender(); // Make sure that the buttons still have their styling after this rerendering
  },
  postAddData: function () {
      var value = $('#' + this.settings.id + '_input').val().trim().replace(/  /g, ' ');
      if (value.length == 0) {
          return false
      }

      gNotifier.saving();
      var self = this;
      $.post('/api/1.0/labels', JSON.stringify({
          name: value,
          created_by: this.settings.createdBy,
      }))
          .done(function (_data) {
              $.get(_data)
                  .done(function (_data) {
                      self.value = parseInt(_data.id);
                      self.input.val(''); // Clear the input with the name of the new label

                      self.load();

                      self.mgr.markDirty();
                  });
          })
          .fail(function (_msg) { alert("Error:" + _msg.responseText); })
          .always(function (_xhr, _textStatus) { gNotifier.saved(); });
  },
  postSelectData: function (e) {
      var value = parseInt(e.target.value);
      if (value == this.value) {
          return false;
      }

      this.value = value;
      this.mgr.markDirty();
  },
  loadLabel: function (_id, _tab) {
      var self = this;
      var dialog = $('#label_dialog');

      $.ajax('/labels/' + _id + (_tab ? '/' + _tab : ''), { headers: { 'x-mx2-layout': 'content-area' } })
          .done(function (_data) {
              var id = 'label_' + _id;
              dialog.html(_data).dialog({
                  buttons: [{
                      text: _T('close'),
                      id: 'label_dialog_save',
                      class: 'warning',
                      click: function () {
                          dialog.dialog('close');
                      }
                  }],
                  open: postRender,
                  close: function () {
                      var manager = fmBroker.get(id);
                      if (manager != null) {
                          manager.save();
                          if (manager.had_changes) {
                              self.load();
                          }
                          fmBroker.unload(id);
                      }
                      dialog.html('');
                  },
                  modal: true,
                  position: { at: 'top+96' },
                  minWidth: 980,
                  title: _T('Edit label')
              });

              dialog.on('click', '.item_tab a', function () {
                  self.loadLabel(this.dataset.label_id, this.dataset.label_action);
                  return false;
              });

              return false;
          });

      return false;
  }
});

/////////////////////////
// BtnFMLabelReleaseAssigner RELEASE
//

BtnFMLabelReleaseAssigner = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);

      this.settings = _settings;

      this.value = null;

      this.composeControl();
      this.load();
  },
  save: function () {
      this._super();
  },
  composeControl: function () {
      var editDialog = $('<div/>').attr('id', 'label_dialog').css({
          'grid-column': 'span 1',
      });
      this.options = $('<span/>');
      var editAction = $('<button class="button__make-up" id="' + this.settings.id + '_edit"> <div style="display: flex;">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '    <g id="Icon / Edit" clip-path="url(#clip0_401_1404)">\n' +
          '        <path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M12.6667 2.07932C12.502 2.07932 12.3389 2.11176 12.1868 2.17478C12.0346 2.2378 11.8964 2.33017 11.7799 2.44662L2.89854 11.328L2.23348 13.7666L4.67202 13.1015L13.5534 4.2201C13.6699 4.10365 13.7622 3.96541 13.8253 3.81326C13.8883 3.66111 13.9207 3.49804 13.9207 3.33336C13.9207 3.16867 13.8883 3.0056 13.8253 2.85346C13.7622 2.70131 13.6699 2.56307 13.5534 2.44662C13.437 2.33017 13.2987 2.2378 13.1466 2.17478C12.9944 2.11176 12.8314 2.07932 12.6667 2.07932ZM11.7034 1.00777C12.0088 0.881271 12.3361 0.816162 12.6667 0.816162C12.9972 0.816162 13.3246 0.881271 13.63 1.00777C13.9354 1.13427 14.2129 1.31969 14.4466 1.55343C14.6803 1.78717 14.8658 2.06467 14.9923 2.37007C15.1188 2.67547 15.1839 3.0028 15.1839 3.33336C15.1839 3.66392 15.1188 3.99125 14.9923 4.29665C14.8658 4.60205 14.6803 4.87954 14.4466 5.11329L5.44661 14.1133C5.36889 14.191 5.27223 14.2471 5.16619 14.276L1.49952 15.276C1.28086 15.3357 1.04701 15.2736 0.886752 15.1133C0.726488 14.953 0.664386 14.7192 0.724021 14.5005L1.72402 10.8338C1.75294 10.7278 1.80903 10.6312 1.88675 10.5534L10.8868 1.55343C11.1205 1.31969 11.398 1.13427 11.7034 1.00777Z" class="edit_text_color"/>\n' +
          '    </g>\n' +
          '    <defs>\n' +
          '        <clipPath id="clip0_401_1404">\n' +
          '            <rect width="16" height="16" fill="white"/>\n' +
          '        </clipPath>\n' +
          '    </defs>\n' +
          '</svg>\n' +
          '</div>' + _T('Edit label') + '</button>');
      this.input = $('<input class="input__box" type="text" id="' + this.settings.id + '_input" />');

      var divWrapper = $('<div/>').append([this.options, editAction]);

      $('#' + this.settings.id).append([
          divWrapper, // Agregar el nuevo div aquí
          $('<span/>').append([
              this.input,
              $('<button class="button__make-up" id="' + this.settings.id + '_add"> <div style="display: flex;">' +
                  '<svg width="16" height="16" viewBox="0 0 16 16" class="edit_text_color" xmlns="http://www.w3.org/2000/svg">\n' +
                  '<g id="Icon / Add">\n' +
                  '<path id="add_circle" d="M7.25 12H8.75V8.75H12V7.25H8.75V4H7.25V7.25H4V8.75H7.25V12ZM8.00575 16C6.9047 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0767 0.625 11.105C0.208333 10.1334 0 9.09519 0 7.99046C0 6.88571 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92332 1.04167 4.89496 0.625C5.86661 0.208333 6.90481 0 8.00954 0C9.11429 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92169 15.375 4.89008C15.7917 5.85849 16 6.89321 16 7.99425C16 9.09531 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0783 14.9583 11.1099 15.375C10.1415 15.7917 9.10679 16 8.00575 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" class="edit_text_color"/>\n' +
                  '</g>\n' +
                  '</svg>' +
                  '</div>' + _T('Add new label') + '</button>')
                  .click(this.postAddData.bind(this)),
              editDialog


          ])
      ]);

      var self = this;
      editAction.click(function () {
          self.loadLabel($('select[id=' + self.settings.id + '_selector]').val());
          return false;
      });
  },
  load: function () {
      var self = this;
      var verify_selected = function (_data) {
          if (_.isEmpty(_.find(_data.items, function (_l) { return _l.id == self.value; }))) {
              $.get(self.settings.getLabelUrl + self.value)
                  .done(function (_label) {
                      _data.items.unshift(_label);
                      self.onData(_data);
                  })
          } else {
              self.onData(_data);
          }
      };

      if (this.settings.initial) {
          verify_selected(this.settings.initial);
          delete (this.settings.initial);
      } else {
          $.get(this.settings.values).done(function (_data) { verify_selected(_data); });
      }
  },
  set: function (_label) {
      this.value = parseInt(_label);
  },
  get: function () {
      return this.value;
  },
  loadFromData: function (_label) {
      this.value = parseInt(_label.label_id);
  },
  onData: function (_data) {
      this.options.html('');
      var selector = $('<select id="' + this.settings.id + '_selector' + '" class="release-select"></select>');
      this.options.append(selector);
      for (var j in _data.items) {
          var i = _data.items[j];
          var id = this.settings.id + '_option';
          var r_input = $('<option id="' + id + '_' + i.id + '" name="' + id + '" value="' + i.id + '" >' + i.name + '</option>');
          if (i.id == this.value) {
              r_input.prop('selected', true);
          }
          selector.append(r_input);
      }

      selector.change(this.postSelectData.bind(this));

      postRender(); // Make sure that the buttons still have their styling after this rerendering
  },
  postAddData: function () {
      var value = $('#' + this.settings.id + '_input').val().trim().replace(/  /g, ' ');
      if (value.length == 0) {
          return false
      }

      gNotifier.saving();
      var self = this;
      $.post('/api/1.0/labels', JSON.stringify({
          name: value,
          created_by: this.settings.createdBy,
      }))
          .done(function (_data) {
              $.get(_data)
                  .done(function (_data) {
                      self.value = parseInt(_data.id);
                      self.input.val(''); // Clear the input with the name of the new label

                      self.load();

                      self.mgr.markDirty();
                  });
          })
          .fail(function (_msg) { alert("Error:" + _msg.responseText); })
          .always(function (_xhr, _textStatus) { gNotifier.saved(); });
  },
  postSelectData: function (e) {
      var value = parseInt(e.target.value);
      if (value == this.value) {
          return false;
      }

      this.value = value;
      this.mgr.markDirty();
  },
  loadLabel: function (_id, _tab) {
      var self = this;
      var dialog = $('#label_dialog');

      $.ajax('/labels/' + _id + (_tab ? '/' + _tab : ''), { headers: { 'x-mx2-layout': 'content-area' } })
          .done(function (_data) {
              var id = 'label_' + _id;
              dialog.html(_data).dialog({
                  buttons: [{
                      text: _T('close'),
                      id: 'label_dialog_save',
                      class: 'warning',
                      click: function () {
                          dialog.dialog('close');
                      }
                  }],
                  open: postRender,
                  close: function () {
                      var manager = fmBroker.get(id);
                      if (manager != null) {
                          manager.save();
                          if (manager.had_changes) {
                              self.load();
                          }
                          fmBroker.unload(id);
                      }
                      dialog.html('');
                  },
                  modal: true,
                  position: { at: 'top+96' },
                  minWidth: 980,
                  title: _T('Edit label')
              });

              dialog.on('click', '.item_tab a', function () {
                  self.loadLabel(this.dataset.label_id, this.dataset.label_action);
                  return false;
              });

              return false;
          });

      return false;
  }
});

//Territory_new
TerritorySelector = function (_settings) {
  this._create(_settings || {});
};
TerritorySelector.prototype = {
  _create: function (_settings) {
      this.settings = _settings;
      this.container = $(_settings.container[0]);
      this.key_tooltip = _settings.initial.key_tooltip;

      this.continents = _.sortBy(_settings.initial.continents, function (_item) {
          return _item.name.toLowerCase();
      });

      this.territories = _.sortBy(_settings.initial.territories, function (_item) {
          return _item.name.toLowerCase();
      });

      this.selected_territories = _settings.initial.selected_territories;
      this.url_to_save = _settings.post_url;
      this.world = _settings.initial.world;
      this.territories_struct = null;
      this.continents_struct = null;
      this.selected_continent = null;
      this.continents_html_container = null;
      this.territories_html_container = null;
      this._init_territories();
      this._init_continents();

      this._render();
  },

  _render: function () {
      var self = this;

      var link_edit = $('<button class="col-2 button__make-up" href="#" style="margin: 0 0 0 16px;"> <div style="display: flex;">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\\n\' +\n' +
          '          \'    <g id="Icon / Edit" clip-path="url(#clip0_401_1404)">\\n\' +\n' +
          '          \'        <path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M12.6667 2.07932C12.502 2.07932 12.3389 2.11176 12.1868 2.17478C12.0346 2.2378 11.8964 2.33017 11.7799 2.44662L2.89854 11.328L2.23348 13.7666L4.67202 13.1015L13.5534 4.2201C13.6699 4.10365 13.7622 3.96541 13.8253 3.81326C13.8883 3.66111 13.9207 3.49804 13.9207 3.33336C13.9207 3.16867 13.8883 3.0056 13.8253 2.85346C13.7622 2.70131 13.6699 2.56307 13.5534 2.44662C13.437 2.33017 13.2987 2.2378 13.1466 2.17478C12.9944 2.11176 12.8314 2.07932 12.6667 2.07932ZM11.7034 1.00777C12.0088 0.881271 12.3361 0.816162 12.6667 0.816162C12.9972 0.816162 13.3246 0.881271 13.63 1.00777C13.9354 1.13427 14.2129 1.31969 14.4466 1.55343C14.6803 1.78717 14.8658 2.06467 14.9923 2.37007C15.1188 2.67547 15.1839 3.0028 15.1839 3.33336C15.1839 3.66392 15.1188 3.99125 14.9923 4.29665C14.8658 4.60205 14.6803 4.87954 14.4466 5.11329L5.44661 14.1133C5.36889 14.191 5.27223 14.2471 5.16619 14.276L1.49952 15.276C1.28086 15.3357 1.04701 15.2736 0.886752 15.1133C0.726488 14.953 0.664386 14.7192 0.724021 14.5005L1.72402 10.8338C1.75294 10.7278 1.80903 10.6312 1.88675 10.5534L10.8868 1.55343C11.1205 1.31969 11.398 1.13427 11.7034 1.00777Z" class="edit_text_color"/>\\n\' +\n' +
          '          \'    </g>\\n\' +\n' +
          '          \'    <defs>\\n\' +\n' +
          '          \'        <clipPath id="clip0_401_1404">\\n\' +\n' +
          '          \'            <rect width="16" height="16" fill="white"/>\\n\' +\n' +
          '          \'        </clipPath>\\n\' +\n' +
          '          \'    </defs>\\n\' +\n' +
          '          \'</svg>'+
          '</div>' + _T('edit') + '</button>');
      link_edit.bind('click', function () {
          self._open_dialog();
          return false;
      });

      this.container.append($("<div class='ch_target' style='display: flex; align-items: center;'></div>").append(this.continents_struct[this.world.continent_id].html.anchor)
          .append(link_edit)
          .append("<div class='ch' id='" + this.key_tooltip + "'></div>"));

      this._render_popup_container();
  },

  _render_popup_container: function () {
      this.popup_container = $("<div></div>");
      var checkbox_all = $("<div></div>");
      checkbox_all.append(this.continents_struct[this.world.continent_id].html.check);
      checkbox_all.append($("<label for='check_all'>" + _T("entire world") + "</label>"));
      this.popup_container.append(checkbox_all);

      this.continents_html_container = $("<div class='block_selector' id='block_selector_continents'></div>");
      this.continents_html_container.css({
          "display": "inline-block",
          "width": "49%",
          "vertical-align": "top",
          "border": "1px solid #c3c4be",
          "height": "216px",
          "overflow": "hidden"
      });
      this._fill_continents(this.continents_html_container);
      this.popup_container.append(this.continents_html_container);

      this.territories_html_container = $("<div class='block_selector' id='block_selector_territories'></div>");
      this.territories_html_container.css({
          "display": "inline-block",
          "width": "49%",
          "vertical-align": "top",
          "margin-left": "5px",
          "border": "1px solid #c3c4be",
          "height": "216px",
          "overflow": "auto",
          "margin-bottom": "15px"
      });
      this.popup_container.append(this.territories_html_container);

      if (this.selected_continent != null) this._select_continent(this.selected_continent.object.id);
      else this.territories_html_container.html("");
  },

  _set_html_info: function () {
      var parent = this.container.find($("#html_info_territories")).parent();
      $("#html_info_territories").remove();
      parent.prepend(this.continents_struct[this.world.continent_id].html.anchor);
  },

  _save: function () {
      var data_to_save = [];
      for (i_terr in this.territories_struct) {
          var terr = this.territories_struct[i_terr];
          if (terr.state) data_to_save.push(terr.object.id);
      }
      $.post(this.url_to_save, JSON.stringify(data_to_save)).done();
      this.selected_territories = data_to_save.slice(0);

      var label = (this.selected_territories.length === this.territories.length || this.selected_territories.filter(function (elem) { return elem == this.id; }, this.world).length > 0) ?
          _T("entire world") :
          this.selected_territories.length + " " + _T("selected territories");
      this.continents_struct[this.world.continent_id].html.anchor.html(label);
      this._cancel();
  },

  _cancel: function () {
      this._clean_territories();
      this._clean_continents();
      this._init_territories();
      this._init_continents();
      this._set_html_info();
      this._render_popup_container();
  },

  _open_dialog: function () {
      var self = this;
      this.popup_container.dialog({
          modal: true,
          title: _T("country_selector_for_album_licences"),
          width: 800,
          height: 383,
          buttons: [
              {
                  text: _T('cancel'), class: 'warning', click: function () {
                      self._cancel();
                      $(this).dialog('close');
                  }
              },
              { text: _T('save and close'), click: function () { self._save(); $(this).dialog('close'); } }
          ]
      });
  },

  //// TERRITORIES
  _init_territories: function () {
      this.territories_struct = [];
      for (i_terr in this.territories) {
          var terr = this.territories[i_terr];
          var elem_struct = {
              "object": terr,
              "html": null,
              "state": (this.selected_territories.indexOf(this.world.id) > -1 || this.selected_territories.indexOf(terr.id) > -1)
          };
          this._generate_html_territory(elem_struct);
          this.territories_struct[terr.id] = elem_struct;
      }
  },

  _generate_html_territory: function (terr) {
      if (terr.object.id !== this.world.id) {
          var check = $("<input type='checkbox' value='" + terr.object.name + "' id='check_territory_" + terr.object.name + "' data-territory_id='" + terr.object.id + "' />");
          check.css({
              "float": "right",
              "margin-right": "20px"
          });
          check[0].checked = terr.state;
          terr.html = check;
      }
  },

  _clean_territories: function () {
      while (Object.keys(this.territories_struct).length > 0) {
          var ind = Object.keys(this.territories_struct)[0];
          var terr = this.territories_struct[ind];
          terr.object = null;
          terr.state = null;
          if (terr.html != null) terr.html.remove();
          delete this.territories_struct[ind];
      }
  },

  _fill_territories: function (continent_id) {
      var territories_of_continent = this.territories.filter(function (elem) { return elem.continent_id == this }, continent_id);
      for (i_terr in territories_of_continent) {
          var terr = this.territories_struct[territories_of_continent[i_terr].id];
          var check = terr.html;
          var label = $("<label for='check_territory_" + terr.object.name + "'>" + terr.object.name + "</label>");
          label.css({ "display": "block", "width": "95%", "cursor": "pointer" });
          this.territories_html_container.append(this._generate_line_territory(check, label, "territory"));
      }
  },

  _generate_line_territory: function (check, label, type) {
      var self = this;

      if (type == "continent") {
          check.bind('change', function (elem) {
              self._select_all_continent($(this).attr('data_continent_id'), this.checked);
              return false;
          });
      }
      else {
          check.bind('change', function (elem) {
              self._click_territory($(this).attr('data-territory_id'));
              return false;
          });
      }

      var link_all_continent = $("<div></div>").append(check).append(label);
      link_all_continent.bind('mouseover', function (elem) { $(elem.currentTarget).css("background-color", "#CCC"); });
      link_all_continent.bind('mouseout', function (elem) { $(elem.currentTarget).css("background-color", "#FFF"); });
      link_all_continent.css({ "height": "15px", "padding-top": "4px", "cursor": "pointer" });
      return link_all_continent;
  },

  _click_territory: function (terr_id) {
      var terr = this.territories_struct[terr_id];
      var new_state = !terr.state;
      terr.state = new_state;
      this._changing_state_territory_of_continent(new_state, terr.object.continent_id);
      this._changing_state_territory_of_world();
  },

  //// CONTINENTS
  _init_continents: function () {
      this.continents_struct = [];
      for (i_cont in this.continents) {
          var cont = this.continents[i_cont];
          var elem_struct = {
              "object": cont,
              "num_terr": this.territories.filter(function (elem) { return elem.continent_id == this; }, cont.id).length,
              "num_terr_sel": this.territories.filter(function (elem) {
                  return (elem.continent_id == this["cont_id"] && (this["terr_sel"].indexOf(this["world"].id) > -1 || this["terr_sel"].indexOf(elem.id) > -1));
              }, { "cont_id": cont.id, "terr_sel": this.selected_territories, "world": this.world }).length
          };

          if (elem_struct.num_terr == elem_struct.num_terr_sel)
              elem_struct.state = "all";
          else if (elem_struct.num_terr_sel == 0)
              elem_struct.state = "any";
          else
              elem_struct.state = "some";

          this._generate_html_continent(elem_struct);
          this.continents_struct[cont.id] = elem_struct;
      }

      var cont_elem =
          this.continents_struct.filter(
              function (elem) {
                  return elem.num_terr_sel > 0 && elem.object.id != this.continent_id;
              }, this.world);

      this.selected_continent = cont_elem.length > 0 ? cont_elem[0] : null;
  },

  _generate_html_continent: function (cont) {
      var self = this;
      var check = null;
      var anchor = null;
      if (cont.object.name != this.world.name) {
          check = $("<input type='checkbox' value='all continent' id='check_territory_all_continent' data_continent_id='" + cont.object.id + "' />");
          check.css({
              "float": "right",
              "margin-right": "20px"
          });
          check[0].checked = cont.state == "all";
          if (cont.object == null) {
              var a = 0;
          }

          anchor = $("<a href='#' data_continent_id='" + cont.object.id + "'>" + cont.object.name + "</div>")
          anchor.css({
              "display": "block",
              "width": "100%",
              "height": "20px",
              "padding-top": "7px",
              "padding-left": "5px",
              "color": "black"
          });
          if (cont["state"] == "any") anchor.css({ "font-weight": "normal" });
          else anchor.css({ "font-weight": "bold" });
          anchor.bind('mouseover', function (elem) {
              $(elem.currentTarget).css("background-color", "#CCC");
          });
          anchor.bind('mouseout', function (elem) {
              $(elem.currentTarget).css("background-color", "#FFF");
          });
          anchor.bind('click', function (elem) {
              self._select_continent(elem.currentTarget.getAttribute('data_continent_id'));
              return false;
          });
      } else {
          check = $("<input type='checkbox' name='all' value='all' id='check_all' />");
          anchor = $("<span id='html_info_territories' class='text'></span>");
          if (self.selected_territories.length === self.territories.length || self.selected_territories.filter(function (elem) { return elem == this.id; }, self.world).length > 0) {
              check[0].checked = true;
              anchor.html(_T("entire world"));
          } else {
              check[0].checked = false;
              anchor.html(self.selected_territories.length + " " + _T("selected territories"));
          }
          check.bind('change', function (elem) {
              self._change_all_selected_continents(elem.currentTarget.checked);
              return false;
          });
      }

      cont.html = { "check": check, "anchor": anchor };
  },

  _clean_continents: function () {
      while (Object.keys(this.continents_struct).length > 0) {
          var ind = Object.keys(this.continents_struct)[0];
          var cont = this.continents_struct[ind];
          cont.object = null;
          cont.state = null;
          cont.num_terr = 0;
          cont.num_terr_sel = 0;
          delete cont.html;
          delete this.continents_struct[ind];
      }
  },

  _fill_continents: function (container) {
      container.html("");
      for (i_cont in this.continents) {
          var cont = this.continents_struct[this.continents[i_cont].id];
          if (cont.object.id != this.world.continent_id) {
              container.append(cont.html.anchor);
          }
      }
  },

  _select_continent: function (continent_id) {
      this.territories_html_container.html("");
      this._change_selected_continent(continent_id);

      var check = this.continents_struct[continent_id].html.check;
      var label = $("<label for='check_territory_all_continent'>" + _T("whole continent") + "</label>");
      label.css({ "display": "block", "width": "95%", "cursor": "pointer" });

      this.territories_html_container.append(this._generate_line_territory(check, label, "continent"));
      this._fill_territories(continent_id);
  },

  _change_selected_continent: function (continent_id) {
      if (this.selected_continent) {
          this.selected_continent.html.anchor.removeClass("selected");
      }
      this.selected_continent = this.continents_struct[continent_id];
      this.selected_continent.html.anchor.addClass("selected");
  },

  _changing_state_territory_of_continent: function (new_state, continent_id) {
      var cont = this.continents_struct[continent_id];

      if (new_state) cont.num_terr_sel++;
      else cont.num_terr_sel--;

      if (cont.num_terr === cont.num_terr_sel) {
          cont.state = "all";
          cont.html.check[0].checked = true;
      }
      else if (cont.num_terr_sel === 0) {
          cont.state = "any";
          cont.html.anchor.css({ "font-weight": "normal" });
      }
      else if (cont.num_terr_sel === 1 && cont.state == "any") {
          cont.state = "some";
          cont.html.anchor.css({ "font-weight": "bold" });
      }
      else if (cont.num_terr_sel === cont.num_terr - 1 && cont.state == "all") {
          cont.state = "some";
          cont.html.check[0].checked = false;
      }
  },

  _select_all_continent: function (continent_id, new_state) {
      var territories = this.territories_struct.filter(function (elem) { return elem.object.continent_id == this; }, continent_id);
      for (i_terr in territories) {
          var terr = territories[i_terr];
          if (terr.state != new_state) this._changing_state_territory_of_continent(new_state, continent_id);
          terr.state = new_state;
          terr.html[0].checked = new_state;
      }
      this._changing_state_territory_of_world();
  },

  //// WORLD
  _changing_state_territory_of_world: function () {
      var self = this;
      var wd = this.continents_struct[this.world.continent_id];
      var continents = this.continents_struct.filter(function (elem) {
          return elem.num_terr_sel === elem.num_terr && elem.object.id != this.continent_id;
      }, this.world);

      if (continents.length >= this.continents.length - 1) {
          wd.html.check[0].checked = true;
          if (this.territories_struct[this.world.id].state == false) {
              this.territories_struct[this.world.id].state = true;
              self._changing_state_territory_of_continent(true, wd.object.id);
          }
      } else {
          wd.html.check[0].checked = false;
          if (this.territories_struct[this.world.id].state == true) {
              this.territories_struct[this.world.id].state = false;
              self._changing_state_territory_of_continent(false, wd.object.id);
          }
      }
  },

  _change_all_selected_continents: function (new_state) {
      for (i_cont in this.continents_struct) {
          if (this.continents_struct[i_cont].object.id != this.world.continent_id) this._select_all_continent(this.continents_struct[i_cont].object.id, new_state);
      }
  }
};

// BtnFMLicenseSelect RELEASE

BtnFMLicenseReleaseSelect = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      var self = this;
      _settings.onChange = function () {
          return self.onChange();
      };
      _settings.onCCChange = function () {
          self.onChange();
          return self.onCCChange();
      };
      this.selector = new LicenseReleaseSelector(_settings);
  },
  loadFromData: function (_data) {
      this.val(_data[this.field]);
      this.selector.setCCLicense(_data[this.settings.cc_license_terms]);
  },
  onCCChange: function () {
      if (this.mgr) {
          this.mgr.getItem(this.settings.cc_text).input.val(this.selector.cc_chooser.get());
      }
  },
  set: function (_v) {
      this._super(_v);
      this.selector.set(_v);
  },
  get: function () {
      return this.selector.get();
  }
});

// License selector RELEASE

LicenseReleaseSelector = function (_settings) {
  this.create(_settings || {});
};
LicenseReleaseSelector.prototype = {
  create: function (_settings) {
      var e = $('#' + _settings.id);
      var self = this;

      this.settings = _settings;
      this.licenses = { 1: 'copyright', 2: 'creative_commons' };

      this.copyright = $('<div style="display: flex; margin-bottom: 16px;"><input class="input--radio" type="radio" name="license_type" id="license_type_copyright" checked="checked" value="copyright"/> <label class="text" style="padding-left: 16px;" for="license_type_copyright" >Copyright</label></div>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });
      this.creative_commons = $('<div style="display: flex; margin-bottom: 16px;"><input class="input--radio" type="radio" name="license_type" id="license_type_creative_commons" value="creative_commons"/> <label class="text" style="padding-left: 16px;" for="license_type_creative_commons" >Creative Commons</label></div>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });

      this.container = $('<div style="margin-left: 32px;"></div>').attr('id', _settings.id + '_cc_chooser').hide();

      e.append(this.copyright)
          .append(this.creative_commons)
          .append(this.container);

      this.cc_chooser = new CcLicenseReleaseSelector({ id: _settings.id + '_cc_chooser', onChange: function () { return self.onCCChange() } });

      this.container.append(this.cc_chooser);
  },
  destroy: function () {
      this.settings = null;
      this.copyright = null;
      this.creative_commons = null;
      this.container = null;
      this.cc_chooser = null;
      $('input[name=license_type]').unbind('change');
  },
  onChange: function () {
      var v = $('input[name=license_type]:checked').val();
      switch (v) {
          case 'copyright':
              this.type = 1;
              this.resetCCLicense();
              this.container.hide();
              break;
          case 'creative_commons':
              this.type = 2;
              this.setDefaultCCLicense();
              this.container.show();
              break;
      }
      if (this.settings.onChange) this.settings.onChange();
  },
  onCCChange: function () {
      if (this.settings.onCCChange) this.settings.onCCChange();
  },
  set: function (_type) {
      this.type = _type;
      $('input[name=license_type][value=' + this.licenses[this.type] + ']').prop('checked', true);
      this.type == 1 ? this.container.hide() : this.container.show();
  },
  resetCCLicense: function () {
      $('#license_cc_by').prop('checked', false);
      $('#license_cc_sa').prop('checked', false);
      $('#license_cc_nc').prop('checked', false);
      $('#license_cc_nd').prop('checked', false);
      $('#album_license_terms').val('');
  },
  setDefaultCCLicense: function () {
      $('#license_cc_by').prop('checked', true);
      $('#license_cc_sa').prop('checked', false);
      $('#license_cc_nc').prop('checked', false);
      $('#license_cc_nd').prop('checked', false);
      $('#album_license_terms').val('by');
      this.setDefaultImage();
  },
  setDefaultImage: function () {
      this.cc_chooser.image.fadeOut(
          'fast',
          function () {
              $(this).attr('src', 'http://i.creativecommons.org/l/by/3.0/88x31.png').load(function () {
                  $(this).fadeIn()
              })
          });
  },
  setCCLicense: function (_text) {
      this.cc_chooser.set(_text);
  },
  get: function () {
      return this.type;
  },
  getTerms: function () {
      var str = '';
      if (this.type == 2) return this.cc_chooser.get();
  }
};

CcLicenseReleaseSelector = function (_settings) {
  this.create(_settings || {});
};
CcLicenseReleaseSelector.prototype = {
  create: function (_settings) {
      var e = $('#' + _settings.id);

      this.settings = _settings;

      this.byContainer = $('<div style="display: flex; align-items: center;"></div>');
      this.by = $('<input type="checkbox" id="license_cc_by" value="by" checked="checked" disabled="disabled" class="icon--checkbox checkbox--disabled"/> <label style="padding-left: 16px;" class="text text--disabled" for="license_cc_by" >Attribution</label>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });

      this.saContainer = $('<div style="display: flex; align-items: center;"></div>');
      this.sa = $('<input type="checkbox" id="license_cc_sa" value="sa" class="icon--checkbox"/> <label style="padding-left: 16px;" class="text" for="license_cc_sa" >Share Alike</label>')
          .bind('click', { self: this }, function (_data) {
              _data.data.self.nd.prop('checked', false);
          })
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });

      this.ndContainer = $('<div style="display: flex; align-items: center;"></div>');
      this.nd = $('<input type="checkbox" id="license_cc_nd" value="nd" class="icon--checkbox"/> <label style="padding-left: 16px;" class="text" for="license_cc_nd" >No Derivatives</label>')
          .bind('click', { self: this }, function (_data) {
              _data.data.self.sa.prop('checked', false);
          })
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });

      this.ncContainer = $('<div style="display: flex; align-items: center;"></div>');
      this.nc = $('<input type="checkbox" id="license_cc_nc" value="nc" class="icon--checkbox"/> <label style="padding-left: 16px;" class="text" for="license_cc_nc" >Non-Commercial</label>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });

      this.image = $('<img style="width: 88px; height: 31px; display: block"/>');
      e
          .append(this.byContainer.append(this.by)).append($('<br/>'))
          .append(this.saContainer.append(this.sa)).append($('<br/>'))
          .append(this.ncContainer.append(this.nc)).append($('<br/>'))
          .append(this.ndContainer.append(this.nd)).append($('<br/>'))
          .append($('<div style="width: 88px; height: 31px; display: block" ></div>').append(this.image))
          ;
  },
  set: function (_text) {
      this.license = _text || '';
      this.by.prop('checked', this.license.indexOf('by') >= 0);
      this.nc.prop('checked', this.license.indexOf('nc') >= 0);
      this.nd.prop('checked', this.license.indexOf('nd') >= 0);
      this.sa.prop('checked', this.license.indexOf('sa') >= 0);
      this.onChangeSet();
  },
  get: function () {
      return this.license;
  },
  onChange: function () {
      var data = [];
      if (this.by.prop('checked')) data.push('by');
      if (this.nc.prop('checked')) data.push('nc');
      if (this.nd.prop('checked')) data.push('nd');
      if (this.sa.prop('checked')) data.push('sa');
      var str = data.join('-');
      this.license = str;
      if (this.license.length > 0) {
          this.image.fadeOut(
              'fast',
              function () {
                  $(this).attr('src', 'http://i.creativecommons.org/l/' + str + '/3.0/88x31.png').load(function () {
                      $(this).fadeIn()
                  })
              });
      }
      if (this.settings.onChange) this.settings.onChange();
  },
  onChangeSet: function () {
      var data = [];
      if (this.by.prop('checked')) data.push('by');
      if (this.nc.prop('checked')) data.push('nc');
      if (this.nd.prop('checked')) data.push('nd');
      if (this.sa.prop('checked')) data.push('sa');
      var str = data.join('-');
      this.license = str;
      if (this.license.length > 0) {
          this.image.fadeOut(
              'fast',
              function () {
                  $(this).attr('src', 'http://i.creativecommons.org/l/' + str + '/3.0/88x31.png').load(function () {
                      $(this).fadeIn()
                  })
              });
      }
  }
};

//----------

BtnFMLicenseSelect = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);
      var self = this;
      _settings.onChange = function () {
          return self.onChange();
      };
      _settings.onCCChange = function () {
          self.onChange();
          return self.onCCChange();
      };
      this.selector = new LicenseSelector(_settings);
  },
  loadFromData: function (_data) {
      this.val(_data[this.field]);
      this.selector.setCCLicense(_data[this.settings.cc_license_terms]);
  },
  onCCChange: function () {
      if (this.mgr) {
          this.mgr.getItem(this.settings.cc_text).input.val(this.selector.cc_chooser.get());
      }
  },
  set: function (_v) {
      this._super(_v);
      this.selector.set(_v);
  },
  get: function () {
      return this.selector.get();
  }
});

// License selector

LicenseSelector = function (_settings) {
  this.create(_settings || {});
};
LicenseSelector.prototype = {
  create: function (_settings) {
      var e = $('#' + _settings.id);
      var self = this;

      this.settings = _settings;
      this.licenses = { 1: 'copyright', 2: 'creative_commons' };

      this.copyright = $('<div class="input-radio__container"><input type="radio" name="license_type" id="license_type_copyright" checked="checked" value="copyright"/> <label for="license_type_copyright" >Copyright</label></div>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });
      this.creative_commons = $('<div class="input-radio__container"><input type="radio" name="license_type" id="license_type_creative_commons" value="creative_commons"/> <label for="license_type_creative_commons" >Creative Commons</label></div>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });

      this.container = $('<div></div>').attr('id', _settings.id + '_cc_chooser').hide();

      e.append(this.copyright)
          .append(this.creative_commons)
          .append(this.container);

      this.cc_chooser = new CcLicenseSelector({ id: _settings.id + '_cc_chooser', onChange: function () { return self.onCCChange() } });

      this.container.append(this.cc_chooser);
  },
  destroy: function () {
      this.settings = null;
      this.copyright = null;
      this.creative_commons = null;
      this.container = null;
      this.cc_chooser = null;
      $('input[name=license_type]').unbind('change');
  },
  onChange: function () {
      var v = $('input[name=license_type]:checked').val();
      switch (v) {
          case 'copyright':
              this.type = 1;
              this.resetCCLicense();
              this.container.hide();
              break;
          case 'creative_commons':
              this.type = 2;
              this.setDefaultCCLicense();
              this.container.show();
              break;
      }
      if (this.settings.onChange) this.settings.onChange();
  },
  onCCChange: function () {
      if (this.settings.onCCChange) this.settings.onCCChange();
  },
  set: function (_type) {
      this.type = _type;
      $('input[name=license_type][value=' + this.licenses[this.type] + ']').prop('checked', true);
      this.type == 1 ? this.container.hide() : this.container.show();
  },
  resetCCLicense: function () {
      $('#license_cc_by').prop('checked', false);
      $('#license_cc_sa').prop('checked', false);
      $('#license_cc_nc').prop('checked', false);
      $('#license_cc_nd').prop('checked', false);
      $('#album_license_terms').val('');
  },
  setDefaultCCLicense: function () {
      $('#license_cc_by').prop('checked', true);
      $('#license_cc_sa').prop('checked', false);
      $('#license_cc_nc').prop('checked', false);
      $('#license_cc_nd').prop('checked', false);
      $('#album_license_terms').val('by');
      this.setDefaultImage();
  },
  setDefaultImage: function () {
      this.cc_chooser.image.fadeOut(
          'fast',
          function () {
              $(this).attr('src', 'http://i.creativecommons.org/l/by/3.0/88x31.png').load(function () {
                  $(this).fadeIn()
              })
          });
  },
  setCCLicense: function (_text) {
      this.cc_chooser.set(_text);
  },
  get: function () {
      return this.type;
  },
  getTerms: function () {
      var str = '';
      if (this.type == 2) return this.cc_chooser.get();
  }
};

CcLicenseSelector = function (_settings) {
  this.create(_settings || {});
};
CcLicenseSelector.prototype = {
  create: function (_settings) {
      var e = $('#' + _settings.id);

      this.settings = _settings;
      this.by = $('<input type="checkbox" id="license_cc_by" value="by" checked="checked" disabled="disabled"/> <label for="license_cc_by" >Attribution</label>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });
      this.sa = $('<input type="checkbox" id="license_cc_sa" value="sa"/> <label for="license_cc_sa" >Share Alike</label>')
          .bind('click', { self: this }, function (_data) {
              _data.data.self.nd.prop('checked', false);
          })
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });
      this.nd = $('<input type="checkbox" id="license_cc_nd" value="nd"/> <label for="license_cc_nd" >No Derivatives</label>')
          .bind('click', { self: this }, function (_data) {
              _data.data.self.sa.prop('checked', false);
          })
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });
      this.nc = $('<input type="checkbox" id="license_cc_nc" value="nc"/> <label for="license_cc_nc" >Non-Commercial</label>')
          .bind('change', { self: this }, function (_data) {
              _data.data.self.onChange();
          });

      this.image = $('<img style="width: 88px; height: 31px; display: block"/>');
      e
          .append(this.by).append($('<br/>'))
          .append(this.sa).append($('<br/>'))
          .append(this.nc).append($('<br/>'))
          .append(this.nd).append($('<br/>'))
          .append($('<div style="width: 88px; height: 31px; display: block" ></div>').append(this.image))
          ;
  },
  set: function (_text) {
      this.license = _text || '';
      this.by.prop('checked', this.license.indexOf('by') >= 0);
      this.nc.prop('checked', this.license.indexOf('nc') >= 0);
      this.nd.prop('checked', this.license.indexOf('nd') >= 0);
      this.sa.prop('checked', this.license.indexOf('sa') >= 0);
      this.onChangeSet();
  },
  get: function () {
      return this.license;
  },
  onChange: function () {
      var data = [];
      if (this.by.prop('checked')) data.push('by');
      if (this.nc.prop('checked')) data.push('nc');
      if (this.nd.prop('checked')) data.push('nd');
      if (this.sa.prop('checked')) data.push('sa');
      var str = data.join('-');
      this.license = str;
      if (this.license.length > 0) {
          this.image.fadeOut(
              'fast',
              function () {
                  $(this).attr('src', 'http://i.creativecommons.org/l/' + str + '/3.0/88x31.png').load(function () {
                      $(this).fadeIn()
                  })
              });
      }
      if (this.settings.onChange) this.settings.onChange();
  },
  onChangeSet: function () {
      var data = [];
      if (this.by.prop('checked')) data.push('by');
      if (this.nc.prop('checked')) data.push('nc');
      if (this.nd.prop('checked')) data.push('nd');
      if (this.sa.prop('checked')) data.push('sa');
      var str = data.join('-');
      this.license = str;
      if (this.license.length > 0) {
          this.image.fadeOut(
              'fast',
              function () {
                  $(this).attr('src', 'http://i.creativecommons.org/l/' + str + '/3.0/88x31.png').load(function () {
                      $(this).fadeIn()
                  })
              });
      }
  }
};

RightsLine = function (_settings) {
  this.create(_settings || {});
};
RightsLine.prototype = {
  create: function (_settings) {
      $('#' + _settings.id).autocomplete({
          autofocus: true,
          source: function (_request, _callback) {
              $.get('/api/1.0/right_holders/filter/text/' + encodeURIComponent('%' + _request.term + '%'))
                  .done(function (_data) {
                      _callback(_.map(_data.items, function (_value, _index) {
                          return _value.text;
                      }));
                  });
          }
      });
  }
};

/**
* @param _settings.data Data to be sent. If set 'ids' are ignored.
* @param _settings.ids Accepts a list of tag ids which will be resolved, serialized
*      as json and sent as the data of the post.
*/
postFormData = function (_settings) {
  var form = _settings.form;
  if (!form) {
      form = $('#' + _settings.id)
  }

  form.submit(function () {
      if (_settings.beforeSubmit) {
          _settings.beforeSubmit();
      }
      var data = _settings.data;
      if (data == null || data == 'undefined') {
          var ids = _settings.ids;
          data = {};
          for (var i in ids) {
              var field = $('#' + ids[i]);
              data[field.attr('name')] = ((field.attr('type') == 'checkbox') ? field.is(':checked') : field.val());
          }
          data = JSON.stringify(data);
      }
      $.post(_settings.url, data)
          .done(function (_data, _textStatus, _xhr) {
              if (_settings.onSuccess) {
                  return _settings.onSuccess(_data, _textStatus, _xhr);
              }
          })
          .fail(function (_xhr, _error) {
              if (_settings.onError) {
                  return _settings.onError(_xhr, _error);
              } else {
                  alert("Error:" + _xhr.responseText);
              }
          })
          .always(function (_xhr, _textStatus) {
              var exec_default = true;
              if (_settings.onComplete) {
                  exec_default = _settings.onComplete(_xhr, _textStatus)
              }

              if (exec_default && _xhr.getResponseHeader('Location')) {
                  try {
                      doLoad(_xhr.getResponseHeader('Location'));
                      return;
                  } catch (e) {
                  }
                  window.location = _xhr.getResponseHeader('Location');
              }
          });

      return false;
  });
};

ImageBox = function (_settings) {
  this.create(_settings || {});
};
ImageBox.prototype = {
  create: function (_settings) {
      this.settings = _settings;

      if (!_settings.src) {
          if (_settings.defaultSrc) {
              this.settings.src = _settings.defaultSrc;
          }
      }

      this.render();
  },
  render: function () {
      var element;
      if (this.settings.src) {
          this.image = $('<img/>');
          this.image.hide();
          element = this.image;
          if (this.settings.link) {
              element = $('<a href="' + this.settings.link + '"></a>').append(this.image);
          }
      } else if (this.settings.link) {
          element = $('<a class="empty" href="' + this.settings.link + '"></a>');
      }

      this.settings.element.addClass('thumbnail').append(element);
      if (this.settings.src) {
          this.show_image(this.settings.src);
      }
      if (this.settings.className) {
          this.settings.element.addClass(this.settings.className);
      }
  },
  reload: function (_src) {
      if (_src) {
          this.settings.src = _src;
      }
      var src = this.settings.src + '?' + Math.random();
      if (this.image) {
          var self = this;
          this.image.fadeOut(1000, function () { self.show_image(src); });
      } else {
          this.settings.src = src;
          this.render();
      }
  },
  show_image: function (_src) {
      if (_src) {
          this.image.attr('src', _src);
      }
      var image = this.image;
      this.image.load(function () {
          image.fadeIn(500);
          image.unbind('load');
      });
  }
};

EmailValidatorControl = BtnFMControl.extend({
  init: function (_settings) {
      this._super(_settings);

      this.form = this.settings.field.closest("form");
      this.originalSubmitFn = this.form.submit;
      this.form.submit(function (e) {
          e.preventDefault();
          return false;
      });

      this.submits = this.form.find(':submit');

      this.error_label = $('<label></label>')
          .attr('for', this.settings.field.attr('name'))
          .addClass('error hidden')
          .html(this.settings.message);

      this.settings.field.after(this.error_label);

      if (this.settings.required) {
          this.submits.each(function () {
              $(this).prop('disabled', true);
          });
          this.form.submit(function (e) {
              e.preventDefault();
              return false;
          });
      }

      var self = this;

      this.form.keypress(function (e) {
          if (e.which == 13) {
              var tagName = e.target.tagName.toLowerCase();
              if (tagName !== "textarea") {
                  return self.onValidate(self.settings.field.val());
              }
          }
      });

      this.settings.field.focus(function () {
          $(this).removeClass('error');
      });
      this.settings.field.blur(function () {
          self.onValidate($(this).val());
      });
      this.settings.field.change(function () {
          self.onValidate($(this).val());
      });

      this.settings.field.keypress(function () {
          self.onValidate($(this).val());
      });
  },
  onValidate: function (_email) {
      var result = this.validate(_email);
      if (this.settings.required && _email == "") result = false;
      if (!result) {
          this.form.submit(function (e) {
              e.preventDefault();
              return false;
          });
          this.settings.field.addClass('error');
          this.error_label.removeClass('hidden');
          this.submits.each(function () {
              $(this).prop('disabled', true);
              $(this).addClass('disabled_action');
          });
      } else {
          this.error_label.addClass('hidden');
          this.submits.each(function () {
              $(this).prop('disabled', false);
              $(this).removeClass('disabled_action');
          });
          this.form.submit = this.originalSubmitFn;
      }
      return result;
  },
  validate: function (_email) {
      var emailReg = /\S+@\S+\.\S+/;
      if (!emailReg.test(_email)) {
          return false;
      } else {
          return true;
      }
  }
});
